window.megaMenuData = [
  {
    "title": "By Author",
    "index": [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "R",
      "S",
      "T",
      "V",
      "W",
      "Y",
      "සිංහල"
    ],
    "groupedItems": {
      "සිංහල": [
        {
          "title": "අකිත්මා විතානගේ | Akithma Withanage",
          "url": "/collections/akithma-withanage"
        },
        {
          "title": "අකිල විමංග සෙනෙවිරත්න | Akila Vimanga Senevirathna",
          "url": "/collections/akila-vimanga-senevirathna"
        },
        {
          "title": "අචල උපේන්ද්‍ර ජයතිලක | Achala Upendra Jayathilaka",
          "url": "/collections/achala-upendra-jayathilaka"
        },
        {
          "title": "අචිනි එරන්දිකා රත්නායක | Achini Erandika Rathnayaka",
          "url": "/collections/achini-erandika-rathnayaka"
        },
        {
          "title": "අංජන දුෂ්‍යන්ත | Anjana Dushyantha",
          "url": "/collections/anjana-dushyantha"
        },
        {
          "title": "අතුල ආර් පෙරේරා | Athula R. Perera",
          "url": "/collections/athula-r-perera"
        },
        {
          "title": "අනිශා ජයකොඩි | Anisha Jayakodi",
          "url": "/collections/anisha-jayakodi"
        },
        {
          "title": "අනීශා ජයකොඩි | Aneesha Jayakodi",
          "url": "/collections/aneesha-jayakodi"
        },
        {
          "title": "අනුර B සෙනවිරත්ත | Anura B Senavirathna",
          "url": "/collections/anura-b-senavirathna"
        },
        {
          "title": "අනුර පද්මසිරි දිසානායක | Anura Padmasiri Disanayaka",
          "url": "/collections/anura-padmasiri-disanayaka"
        },
        {
          "title": "අනුරාදි ගජනායක | Anuraadi Gajanayaka",
          "url": "/collections/anuraadi-gajanayaka"
        },
        {
          "title": "අනුරාධ සෙනෙවිරත්න | Anuradha Seneviratna",
          "url": "/collections/anuradha-seneviratna"
        },
        {
          "title": "අනුල ද සිල්වා | Anula De Silva",
          "url": "/collections/anula-de-silva"
        },
        {
          "title": "අපූර්වා මන්දාරමී | Apurwa Mandaram",
          "url": "/collections/apurwa-mandaram"
        },
        {
          "title": "අපූර්වා මන්දාරමී | Apurwa Mandarami",
          "url": "/collections/apurwa-mandarami"
        },
        {
          "title": "අබේරත්න බණ්ඩාර | Abeyrathna Bandara",
          "url": "/collections/abeyrathna-bandara"
        },
        {
          "title": "අභය හේවාවසම් | Abhaya Hewawasam",
          "url": "/collections/abhaya-hewawasam"
        },
        {
          "title": "අභිෂේක විමලවීර | Abhisheka Wimalaweera",
          "url": "/collections/abhisheka-wimalaweera"
        },
        {
          "title": "අභී විමලධර්ම | Abhi Wimaladharma",
          "url": "/collections/abhi-wimaladharma"
        },
        {
          "title": "අයි එම් ආර් ඒ ඊරියගොල්ල | I.M. R. A. Eeriyagolla",
          "url": "/collections/im-r-a-eeriyagolla"
        },
        {
          "title": "අයෝධ්‍යා වේරගේ | Ayodya Werage",
          "url": "/collections/ayodya-werage"
        },
        {
          "title": "අරලියා පෙරේරා | Araliya Perera",
          "url": "/collections/araliya-perera"
        },
        {
          "title": "අරවින්ද රත්මල්ගම | Aravinda Rathmalgama",
          "url": "/collections/aravinda-rathmalgama"
        },
        {
          "title": "අරුණි මුතුමලී | Aruni Muthumali",
          "url": "/collections/aruni-muthumali"
        },
        {
          "title": "අශානි ශාලිකා රණසිංහ | Ashani Shalika Ranasingha",
          "url": "/collections/ashani-shalika-ranasingha"
        },
        {
          "title": "අසෙනි වර්ෂා | Aseni Warsha",
          "url": "/collections/aseni-warsha"
        },
        {
          "title": "ආචාර්ය ආර් කේ රෝහන් සිසිරකුමාර | Dr R K Rohan Sisirakumara",
          "url": "/collections/dr-r-k-rohan-sisirakumara"
        },
        {
          "title": "ආරියරත්න චන්ද්‍රවංශ | Ariyarathna chandrawansha",
          "url": "/collections/ariyarathna-chandrawansha"
        },
        {
          "title": "ආශ්‍යා අභයදාස | Ashya Abhayadasa",
          "url": "/collections/ashya-abhayadasa"
        },
        {
          "title": "ඇනෙට්මාරි ජසින්තා | Annetmari Jasintha",
          "url": "/collections/annetmari-jasintha"
        },
        {
          "title": "ඇන්ජලී බංඩාර | Anjali Bandaara",
          "url": "/collections/anjali-bandaara"
        },
        {
          "title": "ඇන්ටන් බී. පෙරේරා | Anton B. Perera",
          "url": "/collections/anton-b-perera"
        },
        {
          "title": "ඇලානා මධුරාගොඩ | Alana Maduragoda",
          "url": "/collections/alana-maduragoda"
        },
        {
          "title": "ඉ ක ජිනදාස | I K Jinadasa",
          "url": "/collections/i-k-jinadasa"
        },
        {
          "title": "ඉන්දික ඒ ඈපා සෙනවිරත්න | Indika A Epaa Senavirathna",
          "url": "/collections/indika-a-epaa-senavirathna"
        },
        {
          "title": "ඉන්දීවරී දිබුල්ගස්තැන්න | Indeewari Dimbulgasthenna",
          "url": "/collections/indeewari-dimbulgasthenna"
        },
        {
          "title": "ඉන්ද්‍රා පුෂ්පානි ජයවර්ධන | Indra Pushparani Jayawardana",
          "url": "/collections/indra-pushparani-jayawardana"
        },
        {
          "title": "ඉමේෂා මාධවී මල්ලවආරච්චි | Imesha Madhavi Mallawaarachchi",
          "url": "/collections/imesha-madhavi-mallawaarachchi"
        },
        {
          "title": "ඉමේෂ් මධුශංක යාපා | Imesh Madhushanka Yaapaa",
          "url": "/collections/imesh-madhushanka-yaapaa"
        },
        {
          "title": "ඉරූෂා ග්‍රේරෝ | Iroosha Grero",
          "url": "/collections/iroosha-grero"
        },
        {
          "title": "උඩකරවිට තිලක් B අමරසිංහ | Udakarawita Thilak B Amarasingha",
          "url": "/collections/udakarawita-thilak-b-amarasingha"
        },
        {
          "title": "උදය ශාන්ත කුමාරසිංහ | UdayaShantha Kumarasingha",
          "url": "/collections/udayashantha-kumarasingha"
        },
        {
          "title": "උදේනි දෙල්ගහවත්ත | Udeni Delgahawaththa",
          "url": "/collections/udeni-delgahawaththa"
        },
        {
          "title": "උදේශිකා වික්‍රමාරච්චි | Udeshika Wickramarachchi",
          "url": "/collections/udeshika-wickramarachchi"
        },
        {
          "title": "උපාලි උබයසේකර | Upali Ubayasekara",
          "url": "/collections/upali-ubayasekara"
        },
        {
          "title": "උපාලි කන්නන්ගර | Upali Kannangara",
          "url": "/collections/upali-kannangara"
        },
        {
          "title": "උපාලි ගජනායක | Upali Gajanayaka",
          "url": "/collections/upali-gajanayaka"
        },
        {
          "title": "උපාලි රත්නායක | Upali Rathnayake",
          "url": "/collections/upali-rathnayake"
        },
        {
          "title": "උපුල් රංජිත් හේවාවිතානගමගේ | Upul Ranjith HewaVithanagamage",
          "url": "/collections/upul-ranjith-hewavithanagamage"
        },
        {
          "title": "උපුල් ශාන්ත සන්නස්ගල | Upul Shantha Sannasgala",
          "url": "/collections/upul-shantha-sannasgala"
        },
        {
          "title": "උපෙක්ෂණ අනුහස් | Upekshana Anuhas",
          "url": "/collections/upekshana-anuhas"
        },
        {
          "title": "උමා ෆනැන්ඩෝ | Uma Fernando",
          "url": "/collections/uma-fernando"
        },
        {
          "title": "උමේෂිකා සෙව්වන්දි | Umeshika Sewwandi",
          "url": "/collections/umeshika-sewwandi"
        },
        {
          "title": "එච්. එස්. ක්‍රිශාන්ති | H.S. Krishanthi",
          "url": "/collections/hs-krishanthi"
        },
        {
          "title": "එඩ්නා මල්කාන්ති | Edna Malkanthi",
          "url": "/collections/edna-malkanthi"
        },
        {
          "title": "එඩ්වින් රණවක | Edwin Ranawaka",
          "url": "/collections/edwin-ranawaka"
        },
        {
          "title": "එන් .පි . විජේරත්න | N.P.Wijerathna",
          "url": "/collections/npwijerathna"
        },
        {
          "title": "එම් . ඩ් .එල් . ගුණරත්න | M . D . L . Gunarathna",
          "url": "/collections/m-d-l-gunarathna"
        },
        {
          "title": "එරන්ද රත්නසේකර | Eranda Rathnasekara",
          "url": "/collections/eranda-rathnasekara"
        },
        {
          "title": "එරන්දි නිමාෂා කුරුප්පු | Erandi Nimasha Kuruppu",
          "url": "/collections/erandi-nimasha-kuruppu"
        },
        {
          "title": "එරික් ඉලයප්ආරච්චි | Erik Illayppaarachchi",
          "url": "/collections/erik-illayppaarachchi"
        },
        {
          "title": "එල්.එස්.විච්ක්රමසිංහ | L.S.Wicramasingha",
          "url": "/collections/lswicramasingha"
        },
        {
          "title": "එෂාන් ගුණසේකර | Eshan Goonesekera",
          "url": "/collections/eshan-goonesekera"
        },
        {
          "title": "එස්. එම්. බන්දුසීල | S M Banduseela",
          "url": "/collections/s-m-banduseela"
        },
        {
          "title": "ඒ. පී. ගුණරත්න | A.P.Gunarathne",
          "url": "/collections/apgunarathne"
        },
        {
          "title": "ඒ.සයිමන් ද සිල්වා | A.Symon De Silva",
          "url": "/collections/asymon-de-silva"
        },
        {
          "title": "ඔභාෂිත කාංගර | Obashitha Kangara",
          "url": "/collections/obashitha-kangara"
        },
        {
          "title": "ඕෂධී ජයසිංහ | Oshadi Jayasinghe",
          "url": "/collections/oshadi-jayasinghe"
        },
        {
          "title": "කත්‍යනා අමරසිංහ | Kathyana Amarasingha",
          "url": "/collections/kathyana-amarasingha"
        },
        {
          "title": "කමල් නෙළුන්දෙනිය | Kamal Nelundeniya",
          "url": "/collections/kamal-nelundeniya"
        },
        {
          "title": "කරුණාතිලක හඳුන්පතිරණ | Karunathilaka Handunpathirana",
          "url": "/collections/karunathilaka-handunpathirana"
        },
        {
          "title": "කල්පනා කස්තුරිආරච්චි | Kalpana Kasthuriarachchi",
          "url": "/collections/kalpana-kasthuriarachchi"
        },
        {
          "title": "කව්ෂල්යා හෙට්ටිආරච්චි | Kawshalya Hettiarachchi",
          "url": "/collections/kawshalya-hettiarachchi"
        },
        {
          "title": "කසුන් මහේන්ද්‍ර හීනටිගල | Kasun Mahendra Heenatigala",
          "url": "/collections/kasun-mahendra-heenatigala"
        },
        {
          "title": "කාංචනමාලා ශ්‍රී දේවි | N S Kanchanamala",
          "url": "/collections/n-s-kanchanamala"
        },
        {
          "title": "කාංචනා අමිලානි | Kanchana Amilani",
          "url": "/collections/kanchana-amilani"
        },
        {
          "title": "කාංචනා අලහප්පෙරුම | Kanchana Alahapperuma",
          "url": "/collections/kanchana-alahapperuma"
        },
        {
          "title": "කාංචනා කුඹුරේගෙදර | Kanchana Kumburegedara",
          "url": "/collections/kanchana-kumburegedara"
        },
        {
          "title": "කාංචනා ප්‍රියකාන්ත | Kanchana Priyakantha",
          "url": "/collections/kanchana-priyakantha"
        },
        {
          "title": "කාවින්ද්‍යා රත්නායක | Kavindya Rathnayake",
          "url": "/collections/kavindya-rathnayake"
        },
        {
          "title": "කැලුම් වැලිගම | Kalum Weligama",
          "url": "/collections/kalum-weligama"
        },
        {
          "title": "කැලුම් වැලිගම | Kelum Weligama",
          "url": "/collections/kelum-weligama"
        },
        {
          "title": "කිම් සූ අහ | Kim Suu Ah",
          "url": "/collections/kim-suu-ah"
        },
        {
          "title": "කුමාර සිරිවර්ධන | Kumara Sirewardana",
          "url": "/collections/kumara-sirewardana"
        },
        {
          "title": "කුමාරි කටුකුරුන්ද රත්නායක | Kumari Katukurunda Rathnayake",
          "url": "/collections/kumari-katukurunda-rathnayake"
        },
        {
          "title": "කුෂාන් ද සිල්වා | Kushan De silva",
          "url": "/collections/kushan-de-silva"
        },
        {
          "title": "කුසුම් විතාරණ | Kusum Vitharana",
          "url": "/collections/kusum-vitharana"
        },
        {
          "title": "කේ. ඒ. එන්. පෙරේරා | K A N Perera",
          "url": "/collections/k-a-n-perera"
        },
        {
          "title": "කෝශලී සිරිචන්ද්‍ර | Koshali Sirichandra",
          "url": "/collections/koshali-sirichandra"
        },
        {
          "title": "කෞෂි මුතුකුමාරණ | Kaushi Muthukumarana",
          "url": "/collections/kaushi-muthukumarana"
        },
        {
          "title": "ක්‍රිශානි සඳමාලි මුණසිංහ | Krishani Sadamali Munasinha",
          "url": "/collections/krishani-sadamali-munasinha"
        },
        {
          "title": "ගංගා නිරෝෂිනී සුදුවැලිකන්ද | Ganga Niroshini SuduWalikanda",
          "url": "/collections/ganga-niroshini-suduwalikanda"
        },
        {
          "title": "ගංගා ෂයිනි ගමගේ | Ganga Shayini Gamage",
          "url": "/collections/ganga-shayini-gamage"
        },
        {
          "title": "ගයනා එස්. ලක්මාලි | Gayana S. Lakmali",
          "url": "/collections/gayana-s-lakmali"
        },
        {
          "title": "ගයාත්‍රි වීරකෝන් | Gayathri Weerakoon",
          "url": "/collections/gayathri-weerakoon"
        },
        {
          "title": "ගයාන් සම්පත් වනිගනෙත්ති | Gayan Sampath Waniganeththi",
          "url": "/collections/gayan-sampath-waniganeththi"
        },
        {
          "title": "ගලගොඩ ධනුෂ්ක | Galagoda Dhanushka",
          "url": "/collections/galagoda-dhanushka"
        },
        {
          "title": "ගාමිණි කුමාර විතාන | Gamini Kumara Withana",
          "url": "/collections/gamini-kumara-withana"
        },
        {
          "title": "ගාමිණි විජේරත්න | Gamini Wijerathna",
          "url": "/collections/gamini-wijerathna"
        },
        {
          "title": "ගාවේද් රඛිත රාජපක්ෂ | Gaveed Rakhitha Rajapaksha",
          "url": "/collections/gaveed-rakhitha-rajapaksha"
        },
        {
          "title": "ගිම්ගනී වාසනා | Gimhani Wasana",
          "url": "/collections/gimhani-wasana"
        },
        {
          "title": "ගිහාන් මෙන්ඩිස් | Gihan Mendis",
          "url": "/collections/gihan-mendis"
        },
        {
          "title": "ගීතාංජලී හෙට්ටිආරච්චි | Geethanjalee Hettiarachchi",
          "url": "/collections/geethanjalee-hettiarachchi"
        },
        {
          "title": "ගුණදාස ලියනගේ | Gunadasa Liyanage",
          "url": "/collections/gunadasa-liyanage"
        },
        {
          "title": "ගුණසේකර ගුණසෝම | Gunasekara Gunasoma",
          "url": "/collections/gunasekara-gunasoma"
        },
        {
          "title": "ගෙහාන් ද සිල්වා විජයරත්න | Gehan de Silva Wijeyeratne",
          "url": "/collections/gehan-de-silva-wijeyeratne"
        },
        {
          "title": "ගෝඨාභය රාජපක්ෂ | Gotabaya Rajapaksha",
          "url": "/collections/gotabaya-rajapaksha"
        },
        {
          "title": "ගෞරි තනොජා ද සිල්වා | Gauri Thanoja De Silva",
          "url": "/collections/gauri-thanoja-de-silva"
        },
        {
          "title": "චතුමිණී දිසානායක | Chathumini Disanayaka",
          "url": "/collections/chathumini-disanayaka"
        },
        {
          "title": "චතුර නදීශාන් වලාකුළු | Chathura Nadeshan Wlakulu",
          "url": "/collections/chathura-nadeshan-wlakulu"
        },
        {
          "title": "චතුරංගනී රත්නවීර | Chathurangani Rathnaweera",
          "url": "/collections/chathurangani-rathnaweera"
        },
        {
          "title": "චතුරි වාසනා විජේසිංහ | Chathuri Wasana Wijesinghe",
          "url": "/collections/chathuri-wasana-wijesinghe"
        },
        {
          "title": "චන්දන ගුණසේකර | Chandana Gunaseekara",
          "url": "/collections/chandana-gunaseekara"
        },
        {
          "title": "චන්දන මෙන්ඩිස් | Chandana Mendis",
          "url": "/collections/chandana-mendis"
        },
        {
          "title": "චන්දන සූරියබණ්ඩාර | Chandana Sooriyabandara",
          "url": "/collections/chandana-sooriyabandara"
        },
        {
          "title": "චන්දි කොඩිකාර | Chandi Kodikara",
          "url": "/collections/chandi-kodikara"
        },
        {
          "title": "චන්දිමා හර්ෂනී | Chandima Harshani",
          "url": "/collections/chandima-harshani"
        },
        {
          "title": "චන්ද්‍රසිරි දොඩන්ගොඩ | Chandrasiri Dodangoda",
          "url": "/collections/chandrasiri-dodangoda"
        },
        {
          "title": "චන්ද්‍රසිරි සෙනවිරත්න | ChandraSiri Senavirathna",
          "url": "/collections/chandrasiri-senavirathna"
        },
        {
          "title": "චන්ද්‍රසේන පෙරේරා | Chandrasena Perera",
          "url": "/collections/chandrasena-perera"
        },
        {
          "title": "චන්ද්‍රා අමරසේකර | Chandra Amarasekara",
          "url": "/collections/chandra-amarasekara"
        },
        {
          "title": "චමි තියඹරාහේනේ ගෙදර | Chami Thiyambarahene Gedara",
          "url": "/collections/chami-thiyambarahene-gedara"
        },
        {
          "title": "චමිල් හර්ෂණ එදිරිසිංහ | Chamil Harshana Edirisinghe",
          "url": "/collections/chamil-harshana-edirisinghe"
        },
        {
          "title": "චම්පිකා තමරා ගුණසේකර | Champika Thamara Gunasekara",
          "url": "/collections/champika-thamara-gunasekara"
        },
        {
          "title": "චලනි එම්. අලහකෝන් | Chalani M Alahakoon",
          "url": "/collections/chalani-m-alahakoon"
        },
        {
          "title": "චාප දෙනුවන් | Chapa Denuwan",
          "url": "/collections/chapa-denuwan"
        },
        {
          "title": "චාමර සුමනපාල | Chamara Sumanapala",
          "url": "/collections/chamara-sumanapala"
        },
        {
          "title": "චාරුන්‍යා දෙහිගම | Charunya Dehigama",
          "url": "/collections/charunya-dehigama"
        },
        {
          "title": "චිත්‍රා අමරසේකර | Chithra Amarasekara",
          "url": "/collections/chithra-amarasekara"
        },
        {
          "title": "චිත්‍රා අයි පෙරේරා | Chithra I. Perera",
          "url": "/collections/chithra-i-perera"
        },
        {
          "title": "චින්තක විදානපතිරණ | Chinthaka Widanapathirana",
          "url": "/collections/chinthaka-widanapathirana"
        },
        {
          "title": "චින්තන ධර්මදාස | Chinthana Dharmadhasa",
          "url": "/collections/chinthana-dharmadhasa"
        },
        {
          "title": "චින්තනී අමරසිංහ | Chinthani Amarasinghe",
          "url": "/collections/chinthani-amarasinghe"
        },
        {
          "title": "චින්තා ලක්‍ෂමි සිංහආරච්චි | Chintha Lakshmi Sinhaarachchi",
          "url": "/collections/chintha-lakshmi-sinhaarachchi"
        },
        {
          "title": "චිරංජි රණතුංග | Chiranji Ranathunga",
          "url": "/collections/chiranji-ranathunga"
        },
        {
          "title": "චූලාභය ශාන්ත කුමාර හේරත් | Chulabhaya Shantha Kumara Herath",
          "url": "/collections/chulabhaya-shantha-kumara-herath"
        },
        {
          "title": "චෙරි මින්ෂි | Cherry Minshi",
          "url": "/collections/cherry-minshi"
        },
        {
          "title": "චේතනා ද සිල්වා | Chethana De Silva",
          "url": "/collections/chethana-de-silva"
        },
        {
          "title": "ජයතිලක කම්මැල්ලවීර | Jayathilaka Kammallaweera",
          "url": "/collections/jayathilaka-kammallaweera"
        },
        {
          "title": "ජයතිලක භද්‍රජී මහින්ද | Bhadraji Mahinda Jayathilaka",
          "url": "/collections/bhadraji-mahinda-jayathilaka"
        },
        {
          "title": "ජේ.කේ.කුමාරදාස | J.K. Kumaradasa",
          "url": "/collections/jk-kumaradasa"
        },
        {
          "title": "ජෝන් දිනේෂ් | John Dinesh",
          "url": "/collections/john-dinesh"
        },
        {
          "title": "ටානිකා රුද්‍රීගූ | Tanika Rudhrigu",
          "url": "/collections/tanika-rudhrigu"
        },
        {
          "title": "ටිම්රාන් කීර්ති | Timran Keerthi",
          "url": "/collections/timran-keerthi"
        },
        {
          "title": "ටිරෝනි වැවලගේ | Tironi Wawalage",
          "url": "/collections/tironi-wawalage"
        },
        {
          "title": "ටී.බී.ඉලංගරත්න | T. B. Ilangaratne",
          "url": "/collections/t-b-ilangaratne"
        },
        {
          "title": "ටෙනිසන් පෙරේරා | Tenison Perera",
          "url": "/collections/tenison-perera"
        },
        {
          "title": "ඩබ්.ඕ.ටී. ප්‍රනාන්දු | W.O.T. Fernando",
          "url": "/collections/wot-fernando"
        },
        {
          "title": "ඩබ්ලිව්.ඒ.ධනපාල | W.A.Dhanapala De Silva",
          "url": "/collections/wadhanapala-de-silva"
        },
        {
          "title": "ඩි.එම්.අනුර දිසානායක | D.M. Anura Dissanayake",
          "url": "/collections/dm-anura-dissanayake"
        },
        {
          "title": "ඩිලාන් ඩී. ප්‍රසංග | Dilan D. Prasanga",
          "url": "/collections/dilan-d-prasanga"
        },
        {
          "title": "ඩිල්ශානි චතුරිකා දාබරේ | Dilshani Chathurika Dabare",
          "url": "/collections/dilshani-chathurika-dabare"
        },
        {
          "title": "ඩිල්හාරි ප්‍රනාන්දු | Dilhari Fernando",
          "url": "/collections/dilhari-fernando"
        },
        {
          "title": "ඩී.එම්.තිලකරත්න බණ්ඩා | D.M.Thilakarathna Banda",
          "url": "/collections/dmthilakarathna-banda"
        },
        {
          "title": "ඩේලියා බොතේජු | Deliya Botheju",
          "url": "/collections/deliya-botheju"
        },
        {
          "title": "තක්ෂිලා පැතුම් | Thakshila Pathum",
          "url": "/collections/thakshila-pathum"
        },
        {
          "title": "තත්සරණි බුලත්සිංහල | Thatsarani Bulatsinhala",
          "url": "/collections/thatsarani-bulatsinhala"
        },
        {
          "title": "තනුජා ලුම්බිණි තබවිට | Thanuja Lumbini Thambawita",
          "url": "/collections/thanuja-lumbini-thambawita"
        },
        {
          "title": "තනුෂිකා විතානගේ | Thanushikaa Vithanage",
          "url": "/collections/thanushikaa-vithanage"
        },
        {
          "title": "තරංගා අමාලි පෙරේරා | Tharanga Amali Perera",
          "url": "/collections/tharanga-amali-perera"
        },
        {
          "title": "තරංගා දිසානායක | Tharanga Dissanayake",
          "url": "/collections/tharanga-dissanayake"
        },
        {
          "title": "තරිඳු ෆනෑන්ඩෝ | Tharindu Fernando",
          "url": "/collections/tharindu-fernando"
        },
        {
          "title": "තරුකි ලක්නාරා මනමේන්ද්‍ර | Tharuki Laknara Manamendra",
          "url": "/collections/tharuki-laknara-manamendra"
        },
        {
          "title": "තරුපබා දෙහිදෙණිය | Tharupaba Dehideniya",
          "url": "/collections/tharupaba-dehideniya"
        },
        {
          "title": "තරුප්‍රභා රත්නායක | Tharuprabha Rathnayaka",
          "url": "/collections/tharuprabha-rathnayaka"
        },
        {
          "title": "තරුෂි නිරංගා ජයසිංහ | Tharushi Niranga Jayasingha",
          "url": "/collections/tharushi-niranga-jayasingha"
        },
        {
          "title": "තරුෂි නිරංගා ජයසිංහ | Tharushi Niranga jayasinghe",
          "url": "/collections/tharushi-niranga-jayasinghe"
        },
        {
          "title": "තාරු රාජපක්ෂ | Tharu Rajapaksha",
          "url": "/collections/tharu-rajapaksha"
        },
        {
          "title": "තිසරණී නිර්මාණි | Thisarani Nirmani",
          "url": "/collections/thisarani-nirmani"
        },
        {
          "title": "තිසාරා කරුණාතිලක | Thisara Karunathilaka",
          "url": "/collections/thisara-karunathilaka"
        },
        {
          "title": "තිස්ස අබේසේකර | Tissa Abeysekara",
          "url": "/collections/tissa-abeysekara"
        },
        {
          "title": "තිස්ස හේවාවිස්ස | Thissa Hewawissa",
          "url": "/collections/thissa-hewawissa"
        },
        {
          "title": "තිළිණි දහම්යා ගමගේ | Thilini Dahamya Gamage",
          "url": "/collections/thilini-dahamya-gamage"
        },
        {
          "title": "තුෂාරි අබේසේකර | Thushari Abesekara",
          "url": "/collections/thushari-abesekara"
        },
        {
          "title": "තොම්සන් ඒ. වැන්දබෝනා | Thomson A. Wandabona",
          "url": "/collections/thomson-a-wandabona"
        },
        {
          "title": "දමයන්ති ගල්පායගේ | Damayanthi Galpayage",
          "url": "/collections/damayanthi-galpayage"
        },
        {
          "title": "දමිත් අලගියාවඩු | Damith Alagiyawadu",
          "url": "/collections/damith-alagiyawadu"
        },
        {
          "title": "දමින්ද දිසානායක | Daminda Dissanayake",
          "url": "/collections/daminda-dissanayake"
        },
        {
          "title": "දයා රෝහණ අතුකෝරාල | Daya Rohana Athukorala",
          "url": "/collections/daya-rohana-athukorala"
        },
        {
          "title": "දැදිගම වී. රුද්‍රිගු | Dadigama V. Rudrigu",
          "url": "/collections/dadigama-v-rudrigu"
        },
        {
          "title": "දිනුෂා වීරරත්න | Dinusha Weerarathna",
          "url": "/collections/dinusha-weerarathna"
        },
        {
          "title": "දිමුතු රුවන් | Dimuthu Ruwan",
          "url": "/collections/dimuthu-ruwan"
        },
        {
          "title": "දිමුත් කුලරත්න | Dimuth Kularathna",
          "url": "/collections/dimuth-kularathna"
        },
        {
          "title": "දිලිනි ගයානි ගුණසේකර | Dilini Gayani Gunasekara",
          "url": "/collections/dilini-gayani-gunasekara"
        },
        {
          "title": "දිලිනි වීරකෝන් | Dilini Weerakoon",
          "url": "/collections/dilini-weerakoon"
        },
        {
          "title": "දිලිප් ප්‍රසන්න සෙනවිරත්න | Dilip Prasanna Senewirathna",
          "url": "/collections/dilip-prasanna-senewirathna"
        },
        {
          "title": "දිලීප ජයකොඩි | Dileepa Jayakodi",
          "url": "/collections/dileepa-jayakodi"
        },
        {
          "title": "දිලුක්ෂි හඳපාන්ගොඩ | Dilukshi Handapangoda",
          "url": "/collections/dilukshi-handapangoda"
        },
        {
          "title": "දිලූ සඳමාලි මාපා | Dilu Sandamali Mapa",
          "url": "/collections/dilu-sandamali-mapa"
        },
        {
          "title": "දිලූ සඳමාලි රසංගිකා මාපා | Dilu Sandamali Rasangika Mapa",
          "url": "/collections/dilu-sandamali-rasangika-mapa"
        },
        {
          "title": "දිල්රුක්ෂි ගමගේ | Dilrukshi Gamage",
          "url": "/collections/dilrukshi-gamage"
        },
        {
          "title": "දිල්හානි වික්‍රමරත්න | Dilhani Wikramarathna",
          "url": "/collections/dilhani-wikramarathna"
        },
        {
          "title": "දිල්හාරා සන්දීපනී | Dilhara Sandeepani",
          "url": "/collections/dilhara-sandeepani"
        },
        {
          "title": "දිස්නා පී. සූරියහෙට්ටි | Disna P. Sooriyahetti",
          "url": "/collections/disna-p-sooriyahetti"
        },
        {
          "title": "දුරේන්ද්‍රා ඉන්දිකා පීරිස් | Durendra Indika Peris",
          "url": "/collections/durendra-indika-peris"
        },
        {
          "title": "දුල්මිණි තරංගනි පෙරේරා | Dulmini Tharangani Perera",
          "url": "/collections/dulmini-tharangani-perera"
        },
        {
          "title": "දුල්මිණි තරංගනි පෙරේරා | Tharangani Perera",
          "url": "/collections/tharangani-perera"
        },
        {
          "title": "දෙවිදු රණබාහු | Dewdu Ranabahu",
          "url": "/collections/dewdu-ranabahu"
        },
        {
          "title": "දේවින්දි කව්ශල්‍යා | Devindi Kawshalya",
          "url": "/collections/devindi-kawshalya"
        },
        {
          "title": "ධනංජනී ප්‍රියදර්ශන | Dhananjanee Priyadarshana",
          "url": "/collections/dhananjanee-priyadarshana"
        },
        {
          "title": "ධනවතී ගමගේ | Dhanawathi Gamage",
          "url": "/collections/dhanawathi-gamage"
        },
        {
          "title": "ධම්මිකා විජේසිරි | Dhammika Wijesiri",
          "url": "/collections/dhammika-wijesiri"
        },
        {
          "title": "නදිව් දුල්නිත් | Nadiv Dulnith",
          "url": "/collections/nadiv-dulnith"
        },
        {
          "title": "නදීකා කුමාරගේ | Nadeeka Kumarage",
          "url": "/collections/nadeeka-kumarage"
        },
        {
          "title": "නදීෂා පීරිස් | Nadeesha Peiris",
          "url": "/collections/nadeesha-peiris"
        },
        {
          "title": "නයන තිලක් රත්නායක | Nayana Thilak Rathnayaka",
          "url": "/collections/nayana-thilak-rathnayaka"
        },
        {
          "title": "නයනකේෂී විජේකෝන් | Nayanakeshi Wijekoon",
          "url": "/collections/nayanakeshi-wijekoon"
        },
        {
          "title": "නයනතාරා පිලිපිටිය | Nayanathara Pilipitiya",
          "url": "/collections/nayanathara-pilipitiya"
        },
        {
          "title": "නයනා ජයසිංහ | Nayana Jayasinha",
          "url": "/collections/nayana-jayasinha"
        },
        {
          "title": "නිකිණි නවීනා | Nikini Naweena",
          "url": "/collections/nikini-naweena"
        },
        {
          "title": "නිතූ එදිරිවීර | Nithu Ediriweera",
          "url": "/collections/nithu-ediriweera"
        },
        {
          "title": "නිත්‍ය එස් පෙරේරා | Nithya S Perera",
          "url": "/collections/nithya-s-perera"
        },
        {
          "title": "නිපු මදුෂි වික්‍රමසේකර | Nipu Madushi wickramasekara",
          "url": "/collections/nipu-madushi-wickramasekara"
        },
        {
          "title": "නිපුන් කුමාර කාලිංග | Nipun Kumara Kalinga",
          "url": "/collections/nipun-kumara-kalinga"
        },
        {
          "title": "නිමල් සේදර | Nimal Sedara",
          "url": "/collections/nimal-sedara"
        },
        {
          "title": "නිමල්කා පෙරේරා | Nimalka Perera",
          "url": "/collections/nimalka-perera"
        },
        {
          "title": "නිමේෂා ගීතාංජලී | Nimesha Geethanjali",
          "url": "/collections/nimesha-geethanjali"
        },
        {
          "title": "නිම්මි මුදිතා හේරත් | Nimmi Muditha Herath",
          "url": "/collections/nimmi-muditha-herath"
        },
        {
          "title": "නිරෝෂා අමරසේකර | Nirosha Amarasekara",
          "url": "/collections/nirosha-amarasekara"
        },
        {
          "title": "නිලන්ති එදිරිවීර | Nilanthi Ediriweera",
          "url": "/collections/nilanthi-ediriweera"
        },
        {
          "title": "නිලන්ති වර්ණසූරිය | Nilanthi Warnasooriya",
          "url": "/collections/nilanthi-warnasooriya"
        },
        {
          "title": "නිලේකා ධනංජනී ගුණවර්ධන | Nilekha Dhananjani Gunawardhana",
          "url": "/collections/nilekha-dhananjani-gunawardhana"
        },
        {
          "title": "නිල්මිණී වර්ණකුලසූරිය | Nilmini Warnakulasooriya",
          "url": "/collections/nilmini-warnakulasooriya"
        },
        {
          "title": "නිශාදිනී අල්විස් | Nishadini Alwis",
          "url": "/collections/nishadini-alwis"
        },
        {
          "title": "නිශී බොතේජු | Nishee Botheju",
          "url": "/collections/nishee-botheju"
        },
        {
          "title": "නිශ්ශංක ප්‍රනාන්දු | Nishshanka Pranandu",
          "url": "/collections/nishshanka-pranandu"
        },
        {
          "title": "නිහාල් ගුණසේකර | NIhal Gunasekara",
          "url": "/collections/nihal-gunasekara"
        },
        {
          "title": "නිහාල් ද සිල්වා | Nihal De Silva",
          "url": "/collections/nihal-de-silva"
        },
        {
          "title": "නුමුතු වර්ණකුලසූරිය | Numuthu Warnakulasooriya",
          "url": "/collections/numuthu-warnakulasooriya"
        },
        {
          "title": "නුවන් ඉෂාර මහගමගේ | Nuwan Ishara Mahagamage",
          "url": "/collections/nuwan-ishara-mahagamage"
        },
        {
          "title": "නුවන් ගම්මම්පිල | Nuwan Gammampila",
          "url": "/collections/nuwan-gammampila"
        },
        {
          "title": "නුවන් තොටවත්ත | Nuwan Thotawaththa",
          "url": "/collections/nuwan-thotawaththa"
        },
        {
          "title": "නූ පෙරේරා | Nuu Perera",
          "url": "/collections/nuu-perera"
        },
        {
          "title": "නෙහාන්සා සුරියබණ්ඩාර | Nehansa Sooriyabandara",
          "url": "/collections/nehansa-sooriyabandara"
        },
        {
          "title": "නේත්‍රා එස් ධර්මසේන | Nethra S Dharmasena",
          "url": "/collections/nethra-s-dharmasena"
        },
        {
          "title": "නොර්බට් අයගමගේ | Norbet Ayagamage",
          "url": "/collections/norbet-ayagamage"
        },
        {
          "title": "පද්ම හර්ෂණ කුරනගේ | Padma Harshana Kuranage",
          "url": "/collections/padma-harshana-kuranage"
        },
        {
          "title": "පර්සි ජයමාන්න | Percy Jayamanna",
          "url": "/collections/percy-jayamanna"
        },
        {
          "title": "පවනි උමයංගනා | Pawani Umayangana",
          "url": "/collections/pawani-umayangana"
        },
        {
          "title": "පවනි රාජකරුණා | Pawani Rajakaruna",
          "url": "/collections/pawani-rajakaruna"
        },
        {
          "title": "පවන් අංජන | Pawan Anjana",
          "url": "/collections/pawan-anjana"
        },
        {
          "title": "පවිත්‍රා රූපසින්හ | Pavithra Roopasingh",
          "url": "/collections/pavithra-roopasingh"
        },
        {
          "title": "පාරමී හේනාධීර | Parami Henadeera",
          "url": "/collections/parami-henadeera"
        },
        {
          "title": "පාරමී හේනාධීර | Parami Henadheeara",
          "url": "/collections/parami-henadheeara"
        },
        {
          "title": "පාලි මුණසිංහ | Paali Munasinghe",
          "url": "/collections/paali-munasinghe"
        },
        {
          "title": "පාලිත ජයකොඩි | Palitha Jayakodi",
          "url": "/collections/palitha-jayakodi"
        },
        {
          "title": "පියරිසි මාතරගේ | Piyasiri Matharage",
          "url": "/collections/piyasiri-matharage"
        },
        {
          "title": "පියල් පනාපිටිය | Piyal Panapitiya",
          "url": "/collections/piyal-panapitiya"
        },
        {
          "title": "පියසේන කහඳගමගේ | Piyasena Kahadagamage",
          "url": "/collections/piyasena-kahadagamage"
        },
        {
          "title": "පියුමි ජයකලණිවික්‍රම ආරච්චි | Piyumi Jayakalani Wichramaarachchi",
          "url": "/collections/piyumi-jayakalani-wichramaarachchi"
        },
        {
          "title": "පී.ජී. ඥානසිරි සිල්වා | P.G. Gnanasiri Silva",
          "url": "/collections/pg-gnanasiri-silva"
        },
        {
          "title": "පී.බී.ජයසේකර | P. B. Jayasekara",
          "url": "/collections/p-b-jayasekara"
        },
        {
          "title": "පී.බී.සේනානායක | P.B. Senanayaka",
          "url": "/collections/pb-senanayaka"
        },
        {
          "title": "පුෂ්පිකා විජේරත්න | Pushpika Wijerathne",
          "url": "/collections/pushpika-wijerathne"
        },
        {
          "title": "පූර්ණිමා තිලකරත්න | Poornima Thilakarathna",
          "url": "/collections/poornima-thilakarathna"
        },
        {
          "title": "පෙරීෂා සත්‍යාංගනී | Perisha Sathyangani",
          "url": "/collections/perisha-sathyangani"
        },
        {
          "title": "පොසිකා රණසිංහ | Posika Ranasinghe",
          "url": "/collections/posika-ranasinghe"
        },
        {
          "title": "ප්‍රදීප් කුමාර බාලසුරි | Pradeep kumara Balasooriya",
          "url": "/collections/pradeep-kumara-balasooriya"
        },
        {
          "title": "ප්රදීප් කුමාර බාලසුරිය | Pradip Kumara Balasooriya",
          "url": "/collections/pradip-kumara-balasooriya"
        },
        {
          "title": "ප්‍රදීප් නිශාන්ත හේරත් | Pradeep Nishantha Herath",
          "url": "/collections/pradeep-nishantha-herath"
        },
        {
          "title": "ප්‍රබෝධනී එදිරිසිංහ | Prabodhani Edirisinghe",
          "url": "/collections/prabodhani-edirisinghe"
        },
        {
          "title": "ප්‍රභාත් මිරිහාගල්ල | Prabhath Mirihagalla",
          "url": "/collections/prabhath-mirihagalla"
        },
        {
          "title": "ප්‍රභාත් විතානගේ | Prabhath Withanage",
          "url": "/collections/prabhath-withanage"
        },
        {
          "title": "ප්‍රභාත් සේනාරත්න | Prabhath Senarathna",
          "url": "/collections/prabhath-senarathna"
        },
        {
          "title": "ප්‍රමේෂ් වික්‍රමසිංහ | Pramesh Wickramasinghe",
          "url": "/collections/pramesh-wickramasinghe"
        },
        {
          "title": "ප්‍රසාද් වනසිංහ | Prasad Wanasingha",
          "url": "/collections/prasad-wanasingha"
        },
        {
          "title": "ප්‍රසිලා සිල්වා | Prasila Silva",
          "url": "/collections/prasila-silva"
        },
        {
          "title": "ප්‍රැන්සිකා ප්‍රනාන්දු | Praansikaa Pranaandu",
          "url": "/collections/praansikaa-pranaandu"
        },
        {
          "title": "ප්‍රැන්සිකා ප්‍රනාන්දු | Pransika Fernando",
          "url": "/collections/pransika-fernando"
        },
        {
          "title": "ප්‍රියංක නලින් පිරිස් | Priyanka Nalin Piris",
          "url": "/collections/priyanka-nalin-piris"
        },
        {
          "title": "ප්‍රියනාත් විදානපතිරණ | Priyanath Vidanapathirana",
          "url": "/collections/priyanath-vidanapathirana"
        },
        {
          "title": "ප්‍රේමසිරි මාහිංගොඩ | Premasiri Mahingoda",
          "url": "/collections/premasiri-mahingoda"
        },
        {
          "title": "ප්‍රේම් දිසානායක | Prem Dissanayake",
          "url": "/collections/prem-dissanayake"
        },
        {
          "title": "බටුවන්ගල රාහුල හිමි | Batuwangala Rahula himi",
          "url": "/collections/batuwangala-rahula-himi"
        },
        {
          "title": "බහු කර්තෘ ප්‍රකාශනයකි | Multi-author publications",
          "url": "/collections/multi-author-publications"
        },
        {
          "title": "බුද්ධි එස්. විජේසූරිය | Buddhi S. Wijesooriya",
          "url": "/collections/buddhi-s-wijesooriya"
        },
        {
          "title": "බුද්ධි ජයවීර | Buddhi Jayaweera",
          "url": "/collections/buddhi-jayaweera"
        },
        {
          "title": "බුද්ධිකා අබේසුන්දර | Buddhika Abeysundara",
          "url": "/collections/buddhika-abeysundara"
        },
        {
          "title": "බෝධි විද්‍යාරත්න | Bodhi Vidyarathna",
          "url": "/collections/bodhi-vidyarathna"
        },
        {
          "title": "බ්‍රැඩ්මන් වීරකෝන් | Bradman Weerakon",
          "url": "/collections/bradman-weerakon"
        },
        {
          "title": "මංගල සෝමලාල් රාසිංආරච්චි | Mangala Somalal Rasinaarachchi",
          "url": "/collections/mangala-somalal-rasinaarachchi"
        },
        {
          "title": "මංජුල දිසානායක | Manjula Dissanayake",
          "url": "/collections/manjula-dissanayake"
        },
        {
          "title": "මංජුලා විතානගේ | Manjula Vithanage",
          "url": "/collections/manjula-vithanage"
        },
        {
          "title": "මඩවල එස්. රත්නායක | Madawala S. Rathnayake",
          "url": "/collections/madawala-s-rathnayake"
        },
        {
          "title": "මධාරා අබේසිංහ | Madhara Abesingha",
          "url": "/collections/madhara-abesingha"
        },
        {
          "title": "මධු තිලකරත්න | Madu Thilakarathne",
          "url": "/collections/madu-thilakarathne"
        },
        {
          "title": "මධුෂාණි පිටිගලආරච්චි | Madhushani Pitigalaaarachchi",
          "url": "/collections/madhushani-pitigalaaarachchi"
        },
        {
          "title": "මධුෂිකා දිල්හානි | Madushika Dilhani",
          "url": "/collections/madushika-dilhani"
        },
        {
          "title": "මනිෂා සමරසිංහ | Manishaa Samarasinha",
          "url": "/collections/manishaa-samarasinha"
        },
        {
          "title": "මනුජා විතානගම | Manuja Withanagama",
          "url": "/collections/manuja-withanagama"
        },
        {
          "title": "මනෝ ප්‍රනාන්දු | Mano Fernando",
          "url": "/collections/mano-fernando"
        },
        {
          "title": "මනෝරි සිලිකා වික්‍රමආරච්චි | Manori Silika Wikramaarachchi",
          "url": "/collections/manori-silika-wikramaarachchi"
        },
        {
          "title": "මයිකල් ඇන්ජලෝ ප්‍රනාන්දු | Michael Angelo Fernando",
          "url": "/collections/michael-angelo-fernando"
        },
        {
          "title": "මරියම් ඉම්රාන් | Mariyam Imran",
          "url": "/collections/mariyam-imran"
        },
        {
          "title": "මලික් තුසිත ගුණරත්න | Malik Thusitha Gunarathna",
          "url": "/collections/malik-thusitha-gunarathna"
        },
        {
          "title": "මල්ෂාන් වලිමුණුගේ | Malshan Walimunige",
          "url": "/collections/malshan-walimunige"
        },
        {
          "title": "මල්ෂි එන්. ප්‍රනාන්දු | Malshi N Fernando",
          "url": "/collections/malshi-n-fernando"
        },
        {
          "title": "මහින්ද ප්‍රසාද් මස්ඉඹල | Mahinda Prasad Masibula",
          "url": "/collections/mahinda-prasad-masibula"
        },
        {
          "title": "මහින්ද රැළපනාව | Mahinda Ralapanawa",
          "url": "/collections/mahinda-ralapanawa"
        },
        {
          "title": "මහේෂි වීරකෝන් | Maheshi Weerakoon",
          "url": "/collections/maheshi-weerakoon"
        },
        {
          "title": "මාධවී ජයසිංහ | Madhavi Jayasingha",
          "url": "/collections/madhavi-jayasingha"
        },
        {
          "title": "මාධවී ජයසිංහ | Madhavi Jayasinghe",
          "url": "/collections/madhavi-jayasinghe"
        },
        {
          "title": "මාධවී ජයසිංහ | Madhavi Jayasinha",
          "url": "/collections/madhavi-jayasinha"
        },
        {
          "title": "මාර්ටින් වික්‍රමසිංහ | Martin Wicramasingha",
          "url": "/collections/martin-wicramasingha"
        },
        {
          "title": "මාලිකා තිළිණි අනුරාධා | Malika Thilini Anuradha",
          "url": "/collections/malika-thilini-anuradha"
        },
        {
          "title": "මැණිකේ සුමනසේකර | Manike Sumanasekara",
          "url": "/collections/manike-sumanasekara"
        },
        {
          "title": "මුතුමුදලිගේ නිශ්ශංක | Muthumudalige Nishshanka",
          "url": "/collections/muthumudalige-nishshanka"
        },
        {
          "title": "මුදිත නිශ්ශංක | Muditha Nishshanka",
          "url": "/collections/muditha-nishshanka"
        },
        {
          "title": "මුදිතා කරුණාසිංහ | Mudithaa Karunasinha",
          "url": "/collections/mudithaa-karunasinha"
        },
        {
          "title": "මුදිතා විට්ටච්චි | Muditha Wittachchi",
          "url": "/collections/muditha-wittachchi"
        },
        {
          "title": "මෙත්ජය විජයපාල | Methjaya Wijayapala",
          "url": "/collections/methjaya-wijayapala"
        },
        {
          "title": "මෙත්මල් සුබසිංහ | Methmal Subasinghe",
          "url": "/collections/methmal-subasinghe"
        },
        {
          "title": "මෙලනි අමරතුංග | Melani Amarathunga",
          "url": "/collections/melani-amarathunga"
        },
        {
          "title": "මේජර් ජෙනරාල් කමල් ගුණරත්න | Major General Kamal Gunarathne",
          "url": "/collections/major-general-kamal-gunarathne"
        },
        {
          "title": "මේධි භාෂිණී | Medhi Bhashini",
          "url": "/collections/medhi-bhashini"
        },
        {
          "title": "මොනිකා පුෂ්පකුමාරි | Monika Pushpa Kumari",
          "url": "/collections/monika-pushpa-kumari"
        },
        {
          "title": "මොහාන් ප්‍රියන්ත ආරියවංශ | Mohan Priyantha Ariyawansha",
          "url": "/collections/mohan-priyantha-ariyawansha"
        },
        {
          "title": "මොහාන් රාජ් මඩවල | Mohan Raj Madawala",
          "url": "/collections/mohan-raj-madawala"
        },
        {
          "title": "මොහාන් සමරනායක | Mohan Samaranayaka",
          "url": "/collections/mohan-samaranayaka"
        },
        {
          "title": "යමුනා හේමමාලි ගුණරත්න | Yamuna Hemamali Gunarathna",
          "url": "/collections/yamuna-hemamali-gunarathna"
        },
        {
          "title": "යශ්වානි දේවනාරායන | Yashwani Devanarayana",
          "url": "/collections/yashwani-devanarayana"
        },
        {
          "title": "යසවර්ධන රොද්‍රිගු | Yasawardhana Rodrego",
          "url": "/collections/yasawardhana-rodrego"
        },
        {
          "title": "යාරා සරණී | Yaara Sarani",
          "url": "/collections/yaara-sarani"
        },
        {
          "title": "යේෂා ෆර්නෑන්ඩු | Yesha Fernando",
          "url": "/collections/yesha-fernando"
        },
        {
          "title": "යෞවන සමින්ද්‍ර රත්නායක | Yawwana Samindra Rathnayaka",
          "url": "/collections/yawwana-samindra-rathnayaka"
        },
        {
          "title": "රක්ෂිත දික්කුඹුර | Rakshitha Dikkumbura",
          "url": "/collections/rakshitha-dikkumbura"
        },
        {
          "title": "රංජන් වික්‍රමනායක | Ranjan Wikramanayake",
          "url": "/collections/ranjan-wikramanayake"
        },
        {
          "title": "රංජිත් රෙක්සි ප්‍රනාන්දු | Ranjith Rexi Fernando",
          "url": "/collections/ranjith-rexi-fernando"
        },
        {
          "title": "රනිල් ජයසිංහ | Ranil Jayasingha",
          "url": "/collections/ranil-jayasingha"
        },
        {
          "title": "රන්ජන් ගාමිණි ජයවර්ධන | Ranjan Gamini Jayawardhana",
          "url": "/collections/ranjan-gamini-jayawardhana"
        },
        {
          "title": "රන්ජිත් ආනන්ද ජයසිංහ | Ranjith Ananda Jayasingha",
          "url": "/collections/ranjith-ananda-jayasingha"
        },
        {
          "title": "රන්ජිත් කුරුප්පු | Ranjith Kuruppu",
          "url": "/collections/ranjith-kuruppu"
        },
        {
          "title": "රන්මිණි ජයකොඩි | Ranmini Jayakodi",
          "url": "/collections/ranmini-jayakodi"
        },
        {
          "title": "රමණී බුලත්සිංහල | Ramani Bulathsinhala",
          "url": "/collections/ramani-bulathsinhala"
        },
        {
          "title": "රවින්දි කල්දේරා | Ravindi Kaldera",
          "url": "/collections/ravindi-kaldera"
        },
        {
          "title": "රශ්මි යශෝදා | Rashmi Yashoda",
          "url": "/collections/rashmi-yashoda"
        },
        {
          "title": "රශ්මික මණ්ඩාවල | Rashmika Mandawala",
          "url": "/collections/rashmika-mandawala"
        },
        {
          "title": "රෂාරා ප්‍රියන්ජි ගමගේ | Rashara Priyanji Gamage",
          "url": "/collections/rashara-priyanji-gamage"
        },
        {
          "title": "රාජ ශ්‍රී පීරිස් | Raja Sri Peeris",
          "url": "/collections/raja-sri-peeris"
        },
        {
          "title": "රාජික ගමගේ | Rajika Gamage",
          "url": "/collections/rajika-gamage"
        },
        {
          "title": "රිෂාදි සිත්තරා | Rishadhi Siththara",
          "url": "/collections/rishadhi-siththara"
        },
        {
          "title": "රුවනි ලියන්ගොල්ල | Ruwani Liyangolla",
          "url": "/collections/ruwani-liyangolla"
        },
        {
          "title": "රුවිනි සිල්වා | Ruvini Silva",
          "url": "/collections/ruvini-silva"
        },
        {
          "title": "රුශී ලෝචනා රාජපක්ෂ | Rushi Lochana Rajapaksha",
          "url": "/collections/rushi-lochana-rajapaksha"
        },
        {
          "title": "රොෂානි අචලා අබේසිංහ | Roshani Achala Abeysinghe",
          "url": "/collections/roshani-achala-abeysinghe"
        },
        {
          "title": "රෝමානා බන්නේහෙක | Romana Banneheka",
          "url": "/collections/romana-banneheka"
        },
        {
          "title": "ලලිත් කුමාර බණ්ඩාරනායක | Lalith Kumara Bandaranayaka",
          "url": "/collections/lalith-kumara-bandaranayaka"
        },
        {
          "title": "ලලීන් ගුණරත්න | Lalin Gunarathne",
          "url": "/collections/lalin-gunarathne"
        },
        {
          "title": "ලසිත රවීන් උමගිලිය | Lasitha Raveen Umagiliya",
          "url": "/collections/lasitha-raveen-umagiliya"
        },
        {
          "title": "ලින්ඩා ජයලත් | Linda Jayalath",
          "url": "/collections/linda-jayalath"
        },
        {
          "title": "ලීලානන්ද ගමාච්චි | Leelananda Gamachchi",
          "url": "/collections/leelananda-gamachchi"
        },
        {
          "title": "ලෙටීෂියා බොතේජු | Leteeshiya Botheju",
          "url": "/collections/leteeshiya-botheju"
        },
        {
          "title": "වජිර කස්තුරි | Wajira Kasthuri",
          "url": "/collections/wajira-kasthuri"
        },
        {
          "title": "වත්සලා කරුණාරත්න | Wathsala Karunarathne",
          "url": "/collections/wathsala-karunarathne"
        },
        {
          "title": "වරුණී වාසවදත්තා දේශප්‍රිය | Waruni Wasawadaththa Deshpriya",
          "url": "/collections/waruni-wasawadaththa-deshpriya"
        },
        {
          "title": "වසන්ත පිගේරා | Wasantha Pigera",
          "url": "/collections/wasantha-pigera"
        },
        {
          "title": "වාසනා පෙරේරා | Wasana Perera",
          "url": "/collections/wasana-perera"
        },
        {
          "title": "විනීතා අබේසූරිය | Venetha Abesoriya",
          "url": "/collections/venetha-abesoriya"
        },
        {
          "title": "විනුක වලවගේ | vinuka walawage",
          "url": "/collections/vinuka-walawage"
        },
        {
          "title": "වින්ධ්‍යා එදිරිසිංහ | Vindya Edirisingha",
          "url": "/collections/vindya-edirisingha"
        },
        {
          "title": "විමලදාස සමරසිංහ | Wimaladasa Samarasinghe",
          "url": "/collections/wimaladasa-samarasinghe"
        },
        {
          "title": "විශාකා මහවිතාන | Vishaka Mahavithana",
          "url": "/collections/vishaka-mahavithana"
        },
        {
          "title": "වී.වී.පත්මසිලි | V.V. Pathmaseeli",
          "url": "/collections/vv-pathmaseeli"
        },
        {
          "title": "වෙන්නප්පුවේ පයස් ප්‍රනාන්දු | Wennappuwe Payas Pranandu",
          "url": "/collections/wennappuwe-payas-pranandu"
        },
        {
          "title": "වෙන්ස්ලි ස්ලෙජර්ස් | Wensley Slegers",
          "url": "/collections/wensley-slegers"
        },
        {
          "title": "ශජානි රණසිංහ | Shajani Ranasinghe",
          "url": "/collections/shajani-ranasinghe"
        },
        {
          "title": "ශම්මි පහළගමආරච්චි | Shammi Pahalagamaarachchi",
          "url": "/collections/shammi-pahalagamaarachchi"
        },
        {
          "title": "ශයිනි සුබන්යා ගුණසේකර | Shaini Subanya Gunasekara",
          "url": "/collections/shaini-subanya-gunasekara"
        },
        {
          "title": "ශෂික සදීප් | Shashika Sadeep",
          "url": "/collections/shashika-sadeep"
        },
        {
          "title": "ශෂිනි සේනානායක | Shashini Senanayake",
          "url": "/collections/shashini-senanayake"
        },
        {
          "title": "ශෂේන්ද්‍රි රාජපක්ෂ | Shashendri Rajapaksha",
          "url": "/collections/shashendri-rajapaksha"
        },
        {
          "title": "ශාක්‍ය දෙව්සර දන්තනාරායන | Shakkya Dewsara Danthanarayana",
          "url": "/collections/shakkya-dewsara-danthanarayana"
        },
        {
          "title": "ශානිකා ජයසුරිය | Shanika Jayasuriya",
          "url": "/collections/shanika-jayasuriya"
        },
        {
          "title": "ශාන්ත කුමාර විතාන | Shantha Kumara Vithana",
          "url": "/collections/shantha-kumara-vithana"
        },
        {
          "title": "ශාන්ත කුමාර විතාන | Shantha Kumara Withana",
          "url": "/collections/shantha-kumara-withana"
        },
        {
          "title": "ශාන්තදිස්සනයක | Shanthi Dissanayake",
          "url": "/collections/shanthi-dissanayake-1"
        },
        {
          "title": "ශාන්ති දිසානායක | Shanthi Dissanayake",
          "url": "/collections/shanthi-dissanayake"
        },
        {
          "title": "ශිරෝමි සංඡිවනී | Shiromi Sanjeewani",
          "url": "/collections/shiromi-sanjeewani"
        },
        {
          "title": "ෂමෙල් ජයකොඩි | Shamel Jayakody",
          "url": "/collections/shamel-jayakody"
        },
        {
          "title": "සකුනී හතරසිංහ | Sakuni Hatharasinghe",
          "url": "/collections/sakuni-hatharasinghe"
        },
        {
          "title": "සචින්ද්‍රා ලක්ශ්‍රීණි ගුණසේකර | Sachindra Lakshrini Gunasekara",
          "url": "/collections/sachindra-lakshrini-gunasekara"
        },
        {
          "title": "සචිල නයනජිත් | Sachila Nayanajith",
          "url": "/collections/sachila-nayanajith"
        },
        {
          "title": "සචෙන්‍යා ප්‍රනාන්දු | Sachenya Fernado",
          "url": "/collections/sachenya-fernado"
        },
        {
          "title": "සචෙන්‍යා ප්‍රනාන්දු | Sachenya Fernando",
          "url": "/collections/sachenya-fernando"
        },
        {
          "title": "සංජය දොළමුල්ල | Sanjaya Dolamulla",
          "url": "/collections/sanjaya-dolamulla"
        },
        {
          "title": "සංජලී ලියනගේ | Sanjali Liyanage",
          "url": "/collections/sanjali-liyanage"
        },
        {
          "title": "සංජානා කවින්දි ජයලත් | Sanjana Kavindi Jayalath",
          "url": "/collections/sanjana-kavindi-jayalath"
        },
        {
          "title": "සජිත් කුමාර | Sajith Kumara",
          "url": "/collections/sajith-kumara"
        },
        {
          "title": "සදීශා දොලවත්ත | Sadisha Dolawaththa",
          "url": "/collections/sadisha-dolawaththa"
        },
        {
          "title": "සනත් පියසේන | Sanath Piyasena",
          "url": "/collections/sanath-piyasena"
        },
        {
          "title": "සනත් මහවිතානගේ | Sanath Mahawithanage",
          "url": "/collections/sanath-mahawithanage"
        },
        {
          "title": "සඳ ඇබින්දක් ආදරේ | Chethana Paranavithana",
          "url": "/collections/chethana-paranavithana"
        },
        {
          "title": "සඳුන් ඉරංග රණසිංහ | Sandun Iranga Ranasinghe",
          "url": "/collections/sandun-iranga-ranasinghe"
        },
        {
          "title": "සමන් අතපත්තු | Saman Athapaththu",
          "url": "/collections/saman-athapaththu"
        },
        {
          "title": "සමන් එදිරිමුණි | Saman Edirimuni",
          "url": "/collections/saman-edirimuni"
        },
        {
          "title": "සමන් වික්‍රමාරච්චි | Saman Wickramaarachchi",
          "url": "/collections/saman-wickramaarachchi"
        },
        {
          "title": "සමා ආරච්චි | Samaa Arachchi",
          "url": "/collections/samaa-arachchi"
        },
        {
          "title": "සමීර ඒකනායක | Samira Ekanayaka",
          "url": "/collections/samira-ekanayaka"
        },
        {
          "title": "සමීරා තරංගනී ගල්හේන | Samiraa Tharangani Galhena",
          "url": "/collections/samiraa-tharangani-galhena"
        },
        {
          "title": "සමෝධි බණ්ඩාර | Samodi Bandara",
          "url": "/collections/samodi-bandara"
        },
        {
          "title": "සයිමන් නවගත්තේගම | Symon Nawagaththegama",
          "url": "/collections/symon-nawagaththegama"
        },
        {
          "title": "සරත් කොටගම | Sarath Kotagama",
          "url": "/collections/sarath-kotagama"
        },
        {
          "title": "සරත් විජේසූරිය | Sarath Wijesooriya",
          "url": "/collections/sarath-wijesooriya"
        },
        {
          "title": "සවින්දි ආරියතිලක | Savindi Ariyathilake",
          "url": "/collections/savindi-ariyathilake"
        },
        {
          "title": "සාලිය සේනාසේකර | Saliya Senasekara",
          "url": "/collections/saliya-senasekara"
        },
        {
          "title": "සිඩ්නි මාකස් ඩයස් | Sydney Marcus Dias",
          "url": "/collections/sydney-marcus-dias"
        },
        {
          "title": "සිඩ්නි සිරිවර්ධන | Sydney Siriwardana",
          "url": "/collections/sydney-siriwardana"
        },
        {
          "title": "සිතු ඉඳුවර | Sithu Induwara",
          "url": "/collections/sithu-induwara"
        },
        {
          "title": "සිතුමිණි පලිපාන | Sithumini Palipana",
          "url": "/collections/sithumini-palipana"
        },
        {
          "title": "සිද්ධාංගනී ගමකුමාර | Siddhangani Gamakumara",
          "url": "/collections/siddhangani-gamakumara"
        },
        {
          "title": "සිරිල් චන්ද්‍රසේකර ගුණවර්ධන | Siril Chandrasekara Gunawardhana",
          "url": "/collections/siril-chandrasekara-gunawardhana"
        },
        {
          "title": "සිරිසේන රත්නායක | Sirisena Rathnayaka",
          "url": "/collections/sirisena-rathnayaka"
        },
        {
          "title": "සිසරු මින්හෙසා | Sisuru Minseha",
          "url": "/collections/sisuru-minseha"
        },
        {
          "title": "සීතා මහේන්ද්‍ර | Seetha Mahendra",
          "url": "/collections/seetha-mahendra"
        },
        {
          "title": "සුජිත් චමින්ද එදිරිසිංහ | Sujith Chaminda Edirisingha",
          "url": "/collections/sujith-chaminda-edirisingha"
        },
        {
          "title": "සුජීවා හේමමාලි | Sujeewa Hemamali",
          "url": "/collections/sujeewa-hemamali"
        },
        {
          "title": "සුදත් රොහාන් | Sudath Rohan",
          "url": "/collections/sudath-rohan"
        },
        {
          "title": "සුදාරි බස්නායක | Sudari Basnayaka",
          "url": "/collections/sudari-basnayaka"
        },
        {
          "title": "සුනන්ද දේශප්‍රිය | Sunanda Deshapriya",
          "url": "/collections/sunanda-deshapriya"
        },
        {
          "title": "සුනන්ද මද්දුමබණ්ඩාර | Sunanda Maddumabandara",
          "url": "/collections/sunanda-maddumabandara"
        },
        {
          "title": "සුනිලා විජේසිංහ | Sunila Wijesingha",
          "url": "/collections/sunila-wijesingha"
        },
        {
          "title": "සුනිල් මාධව ප්‍රේමතිලක | Sunil Madawa Premathilaka",
          "url": "/collections/sunil-madawa-premathilaka"
        },
        {
          "title": "සුනිල් වික්‍රමසිංහ | Sunil Wickramasinghe",
          "url": "/collections/sunil-wickramasinghe"
        },
        {
          "title": "සුනේත්‍රා තුෂාරි ඩයස් | Sunethra Thushari Dias",
          "url": "/collections/sunethra-thushari-dias"
        },
        {
          "title": "සුමනදාස කොඩිතුවක්කු | Sumanadasa Kodithuwakku",
          "url": "/collections/sumanadasa-kodithuwakku"
        },
        {
          "title": "සුමනදාස සමරසිංහ | Sumanadasa Samarasinghe",
          "url": "/collections/sumanadasa-samarasinghe"
        },
        {
          "title": "සුරත් ද මැල් | Surath de Mel",
          "url": "/collections/surath-de-mel"
        },
        {
          "title": "සුරේකා නිල්මිණි ඉලංකෝන් | Sureka Nilmini Ilankon",
          "url": "/collections/sureka-nilmini-ilankon"
        },
        {
          "title": "සුලක්ෂනා ධීරසේකර | Sulakshana Dheerasekara",
          "url": "/collections/sulakshana-dheerasekara"
        },
        {
          "title": "සුසිත රුවන් | Susitha Ruwan",
          "url": "/collections/susitha-ruwan"
        },
        {
          "title": "සුහර්ශනී ධර්මරත්න | Suharshanee Dharmarathna",
          "url": "/collections/suharshanee-dharmarathna"
        },
        {
          "title": "සූරිය සිහබාහු | Sooriya Sihabahu",
          "url": "/collections/sooriya-sihabahu"
        },
        {
          "title": "සේනානි ධර්මරත්න | Senani Dharmarathna",
          "url": "/collections/senani-dharmarathna"
        },
        {
          "title": "සෞම්‍ය සඳරුවන් ලියනගේ | Saumya Sandaruwan Liyanage",
          "url": "/collections/saumya-sandaruwan-liyanage"
        },
        {
          "title": "ස්වර්ණකාන්ති රාජපක්ෂ | Swarnakanthi Rjapaksha",
          "url": "/collections/swarnakanthi-rjapaksha"
        },
        {
          "title": "හර්ෂ මල්ලව ආරච්චි | Harsha Mallawa Arachchi",
          "url": "/collections/harsha-mallawa-arachchi"
        },
        {
          "title": "හර්ෂනී සමරතුංග | Harshani Samarathunga",
          "url": "/collections/harshani-samarathunga"
        },
        {
          "title": "හංසනී රණසිංහ | Hansani Ranasinghe",
          "url": "/collections/hansani-ranasinghe"
        },
        {
          "title": "හංසි මේද්‍යා විජේකොන් | Hansi Medya Wjekoon",
          "url": "/collections/hansi-medya-wjekoon"
        },
        {
          "title": "හිරුණි S හේරත් | Hiruni S Hearath",
          "url": "/collections/hiruni-s-hearath"
        },
        {
          "title": "හේලි අබේවික්‍රම | Heli Abewikrama",
          "url": "/collections/heli-abewikrama"
        },
        {
          "title": "හේෂාන් වෙල්ගම | Heshan Welgama",
          "url": "/collections/heshan-welgama"
        },
        {
          "title": "ෆ්‍රෙඩී මනාවඩු | Freddy Manawadu",
          "url": "/collections/freddy-manawadu"
        }
      ],
      "A": [
        {
          "title": "A. S අබේරතන | A. S. Abeyratne",
          "url": "/collections/a-s-abeyratne"
        },
        {
          "title": "A.V සුරවිර | A.V Suraweera",
          "url": "/collections/av-suraweera"
        },
        {
          "title": "Alexandre Dumas",
          "url": "/collections/alexandre-dumas"
        },
        {
          "title": "Andrzej Sapkowski",
          "url": "/collections/andrzej-sapkowski"
        },
        {
          "title": "Arthur Conan Doyle",
          "url": "/collections/arthur-conan-doyle"
        }
      ],
      "B": [
        {
          "title": "Bella Mackie",
          "url": "/collections/bella-mackie"
        },
        {
          "title": "Benjamin Graham",
          "url": "/collections/benjamin-graham"
        }
      ],
      "C": [
        {
          "title": "Charles and Mary Lamb",
          "url": "/collections/charles-and-mary-lamb"
        },
        {
          "title": "Charles Dickens",
          "url": "/collections/charles-dickens"
        },
        {
          "title": "Colleen Hoover",
          "url": "/collections/colleen-hoover"
        }
      ],
      "D": [
        {
          "title": "D.M කරුණාරත්න | D.M.Karunarathna",
          "url": "/collections/dmkarunarathna"
        },
        {
          "title": "Dan Brown",
          "url": "/collections/dan-brown"
        },
        {
          "title": "Daniel Coyle",
          "url": "/collections/daniel-coyle"
        },
        {
          "title": "Dilrukshi Gamage | දිල්රුක්ෂි ගමගේ",
          "url": "/collections/item"
        }
      ],
      "E": [
        {
          "title": "Edith Nesbit",
          "url": "/collections/edith-nesbit"
        },
        {
          "title": "Eleanor H. Porter",
          "url": "/collections/eleanor-h-porter"
        },
        {
          "title": "Elizabeth Gilbert",
          "url": "/collections/elizabeth-gilbert"
        },
        {
          "title": "Emily Bronte",
          "url": "/collections/emily-bronte"
        },
        {
          "title": "Enid Blyton",
          "url": "/collections/enid-blyton"
        }
      ],
      "F": [
        {
          "title": "F. Scott Fitzgerald",
          "url": "/collections/f-scott-fitzgerald"
        },
        {
          "title": "Frances Hodgson Burnett",
          "url": "/collections/frances-hodgson-burnett"
        }
      ],
      "G": [
        {
          "title": "G.A. නාලනී | G.A. Nalini",
          "url": "/collections/ga-nalini"
        },
        {
          "title": "George Eliot",
          "url": "/collections/george-eliot"
        }
      ],
      "H": [
        {
          "title": "H. Rider Haggard",
          "url": "/collections/h-rider-haggard"
        },
        {
          "title": "H.G. Wells",
          "url": "/collections/hg-wells"
        },
        {
          "title": "H.M ජයන්ත විජේරත්න | H.M.Jayantha Wijerathna",
          "url": "/collections/hmjayantha-wijerathna"
        },
        {
          "title": "Hans Christian Andersen",
          "url": "/collections/hans-christian-andersen"
        },
        {
          "title": "Haydn Richards",
          "url": "/collections/haydn-richards"
        },
        {
          "title": "Hector Garcia",
          "url": "/collections/hector-garcia"
        },
        {
          "title": "Holly Black",
          "url": "/collections/holly-black"
        },
        {
          "title": "Holly Jackson",
          "url": "/collections/holly-jackson"
        },
        {
          "title": "Howard Pyle",
          "url": "/collections/howard-pyle"
        }
      ],
      "J": [
        {
          "title": "J.K.Rowling",
          "url": "/collections/jkrowling"
        },
        {
          "title": "J.R.R. Tolkien",
          "url": "/collections/jrr-tolkien"
        },
        {
          "title": "James Clear",
          "url": "/collections/james-clear"
        },
        {
          "title": "James Matthew Barrie",
          "url": "/collections/james-matthew-barrie"
        },
        {
          "title": "Jandy Nelson",
          "url": "/collections/jandy-nelson"
        },
        {
          "title": "Jane Austen",
          "url": "/collections/jane-austen"
        },
        {
          "title": "Jay Shetty",
          "url": "/collections/jay-shetty"
        },
        {
          "title": "Jeff Kinney",
          "url": "/collections/jeff-kinney"
        },
        {
          "title": "Johann David Wyss",
          "url": "/collections/johann-david-wyss"
        },
        {
          "title": "Jordan B. Peterson",
          "url": "/collections/jordan-b-peterson"
        },
        {
          "title": "Jules Verne",
          "url": "/collections/jules-verne"
        }
      ],
      "K": [
        {
          "title": "K.L ජයතිස්ස | K.L.Jayathissa",
          "url": "/collections/kljayathissa"
        },
        {
          "title": "K.M සිරිසේන | K.M.Sirisena",
          "url": "/collections/kmsirisena"
        },
        {
          "title": "K.M සිල්වා | K.M.Silva",
          "url": "/collections/kmsilva"
        },
        {
          "title": "Katy Brent",
          "url": "/collections/katy-brent"
        }
      ],
      "L": [
        {
          "title": "L Frank Baum",
          "url": "/collections/l-frank-baum"
        },
        {
          "title": "L. Frank Baum",
          "url": "/collections/l-frank-baum-2"
        },
        {
          "title": "Lauren Roberts",
          "url": "/collections/lauren-roberts"
        },
        {
          "title": "Lesley Sims",
          "url": "/collections/lesley-sims"
        },
        {
          "title": "Lewis Carroll",
          "url": "/collections/lewis-carroll"
        },
        {
          "title": "Lorna Dewaraja",
          "url": "/collections/lorna-dewaraja"
        },
        {
          "title": "Louisa May Alcott",
          "url": "/collections/louisa-may-alcott"
        }
      ],
      "M": [
        {
          "title": "M.D.L. ගුණරත්න | M.D.L. Gunarathna",
          "url": "/collections/mdl-gunarathna"
        },
        {
          "title": "Mairi Mckinnon",
          "url": "/collections/mairi-mckinnon"
        }
      ],
      "N": [
        {
          "title": "N. මහෙශ්වරී දෙවි | N. Maheswari Devi",
          "url": "/collections/n-maheswari-devi"
        },
        {
          "title": "Napoleon Hill",
          "url": "/collections/napoleon-hill"
        },
        {
          "title": "Nihal Piris",
          "url": "/collections/nihal-piris"
        },
        {
          "title": "Niluka Brandon",
          "url": "/collections/niluka-brandon"
        }
      ],
      "O": [
        {
          "title": "Oscar Wilde",
          "url": "/collections/oscar-wilde"
        }
      ],
      "P": [
        {
          "title": "Paulo Coelho",
          "url": "/collections/paulo-coelho"
        }
      ],
      "R": [
        {
          "title": "René Goscinny",
          "url": "/collections/rene-goscinny"
        },
        {
          "title": "Rhonda Byrne",
          "url": "/collections/rhonda-byrne"
        },
        {
          "title": "Richard Osman",
          "url": "/collections/richard-osman"
        },
        {
          "title": "Rick Riordan",
          "url": "/collections/rick-riordan"
        },
        {
          "title": "Roald Dahl",
          "url": "/collections/roald-dahl"
        },
        {
          "title": "Robert Louis Stevenson",
          "url": "/collections/robert-louis-stevenson"
        },
        {
          "title": "Robert Michael Ballantyne",
          "url": "/collections/robert-michael-ballantyne"
        },
        {
          "title": "Robert T. Kiyosaki",
          "url": "/collections/robert-t-kiyosaki"
        },
        {
          "title": "Robin Sharma",
          "url": "/collections/robin-sharma"
        },
        {
          "title": "Russel Punter",
          "url": "/collections/russel-punter"
        },
        {
          "title": "Russell Punter",
          "url": "/collections/russell-punter"
        }
      ],
      "S": [
        {
          "title": "S ජෝන්රාජ්න් | S Jonhrajan",
          "url": "/collections/s-jonhrajan"
        },
        {
          "title": "S. සමරසිංහම් | S. Samarasingham",
          "url": "/collections/s-samarasingham"
        },
        {
          "title": "S.F.R.A Cader",
          "url": "/collections/sfra-cader"
        },
        {
          "title": "Sarah Courtauld",
          "url": "/collections/sarah-courtauld"
        },
        {
          "title": "Sieglinde Quick",
          "url": "/collections/sieglinde-quick"
        },
        {
          "title": "Stephen M.R. Covey",
          "url": "/collections/stephen-mr-covey"
        },
        {
          "title": "Steve Parker",
          "url": "/collections/steve-parker"
        },
        {
          "title": "Susanna Davidson",
          "url": "/collections/susanna-davidson"
        }
      ],
      "T": [
        {
          "title": "The Brothers Grimm",
          "url": "/collections/the-brothers-grimm"
        }
      ],
      "V": [
        {
          "title": "Victor Hugo",
          "url": "/collections/victor-hugo"
        }
      ],
      "W": [
        {
          "title": "W.A. අබේසිංහ | W.A.Abesingha",
          "url": "/collections/waabesingha"
        },
        {
          "title": "William Shakespeare",
          "url": "/collections/william-shakespeare"
        }
      ],
      "Y": [
        {
          "title": "Yashodha Isuri Marasingha",
          "url": "/collections/yashodha-isuri-marasingha"
        },
        {
          "title": "Yuval Noah Harari",
          "url": "/collections/yuval-noah-harari"
        }
      ]
    }
  },
  {
    "title": "By Category",
    "index": [
      "A",
      "C",
      "E",
      "H",
      "N",
      "P",
      "S",
      "T",
      "සිංහල"
    ],
    "groupedItems": {
      "සිංහල": [
        {
          "title": "අධ්‍යාපනික | Educational",
          "url": "/collections/educational"
        },
        {
          "title": "ඉතිහාස සහ පුරාවිද්‍යාව | History & Archeology",
          "url": "/collections/history-and-archeology"
        },
        {
          "title": "ඉතිහාසය | History",
          "url": "/collections/history"
        },
        {
          "title": "ඓතිහාසික නවකතා | Historical Novels",
          "url": "/collections/historical-novels"
        },
        {
          "title": "කතා පොත් | Story Books",
          "url": "/collections/story-books"
        },
        {
          "title": "කවි | Poetry",
          "url": "/collections/poetry"
        },
        {
          "title": "කෙටි කතා | Short Story",
          "url": "/collections/short-story"
        },
        {
          "title": "චාරිකා සහ සංචාරක සටහන් පොත් | Travel Guide & Tourism Book",
          "url": "/collections/travel-guide-and-tourism-book"
        },
        {
          "title": "ජනකතා | Janakatha",
          "url": "/collections/janakatha"
        },
        {
          "title": "ජෝතිෂ්‍ය | Jothishya",
          "url": "/collections/jothishya"
        },
        {
          "title": "තීරුලිපි | Thirulipi",
          "url": "/collections/thirulipi"
        },
        {
          "title": "දේශපාලන ප්‍රබන්ධ | Political Fiction",
          "url": "/collections/political-fiction"
        },
        {
          "title": "නවකතා | Novel",
          "url": "/collections/novel"
        },
        {
          "title": "නිතිය | Law Book",
          "url": "/collections/law-book"
        },
        {
          "title": "පරිවර්තන | Translations",
          "url": "/collections/translations"
        },
        {
          "title": "පරිවර්තන කෙටි කතා | Translations Short Story",
          "url": "/collections/translations-short-story"
        },
        {
          "title": "පරිවර්තන නවකතා | Translaions Novels",
          "url": "/collections/translaions-novels"
        },
        {
          "title": "පරිවර්තන විද්‍යා ප්‍රබන්ධ | Translation Science Fiction",
          "url": "/collections/translation-science-fiction"
        },
        {
          "title": "බෞද්ධ | Religious Book",
          "url": "/collections/religious-book"
        },
        {
          "title": "මනෝ විද්‍යාව | Psychological",
          "url": "/collections/psychological"
        },
        {
          "title": "යුධ සාහිත්‍ය කෘති | War story",
          "url": "/collections/war-story"
        },
        {
          "title": "යොවුන් නවකතා | Teenagers Novel",
          "url": "/collections/teenagers-novel"
        },
        {
          "title": "රහස් පරීක්ෂණ කතා | Secret Investigation Stories",
          "url": "/collections/secret-investigation-stories"
        },
        {
          "title": "වැඩ පොත් | Work books",
          "url": "/collections/work-books"
        },
        {
          "title": "විද්‍යා ප්‍රබන්ධ | Science Fiction",
          "url": "/collections/science-fiction"
        },
        {
          "title": "විවිධ | Miscellaneous",
          "url": "/collections/miscellaneous"
        },
        {
          "title": "සමාජ විද්‍යාව | SOCIOLOGICAL",
          "url": "/collections/sociological"
        },
        {
          "title": "ස්වභාවධර්ම සහ වනජීවී | Nature & Wildlife",
          "url": "/collections/nature-and-wildlife"
        },
        {
          "title": "ළමා පරිවර්තන | Children's Translations",
          "url": "/collections/childrens-translations"
        }
      ],
      "A": [
        {
          "title": "Academic & Reference",
          "url": "/collections/academic-and-reference"
        }
      ],
      "C": [
        {
          "title": "Childrens Novels",
          "url": "/collections/childrens-novels"
        },
        {
          "title": "Comics & Graphic",
          "url": "/collections/comics-and-graphic"
        }
      ],
      "E": [
        {
          "title": "ENGLISH NOVELS",
          "url": "/collections/english-novels"
        },
        {
          "title": "English story books",
          "url": "/collections/english-story-books"
        }
      ],
      "H": [
        {
          "title": "Health & Fitness",
          "url": "/collections/health-fitness"
        }
      ],
      "N": [
        {
          "title": "New Arrival | නව ග්‍රන්ථ",
          "url": "/collections/new-arrival"
        }
      ],
      "P": [
        {
          "title": "Past Papers O\\L",
          "url": "/collections/past-papers-o-l"
        }
      ],
      "S": [
        {
          "title": "Self Help",
          "url": "/collections/self-help"
        }
      ],
      "T": [
        {
          "title": "Theory",
          "url": "/collections/theory"
        }
      ]
    }
  },
  {
    "title": "By Publisher",
    "index": [
      "#",
      "A",
      "B",
      "C",
      "E",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "R",
      "S",
      "T",
      "U",
      "W",
      "සිංහල"
    ],
    "groupedItems": {
      "සිංහල": [
        {
          "title": "අක්ෂණා ප්‍රකාශකයෝ | Akshanaa Publishers",
          "url": "/collections/akshanaa-publishers"
        },
        {
          "title": "අහස් ප්‍රකාශකයෝ | Ahas Publishers",
          "url": "/collections/ahas-publishers"
        },
        {
          "title": "ආශිර්වාද ප්‍රකාශකයෝ | Ashirwada Prakashana",
          "url": "/collections/ashirwada-prakashana"
        },
        {
          "title": "ආශී ක්‍රියේෂන්ස් | Ashi Creations",
          "url": "/collections/ashi-creations"
        },
        {
          "title": "ඇතේනියම් ප්‍රකාශන | Athenaeum Publication",
          "url": "/collections/athenaeum-publication"
        },
        {
          "title": "ඇස්.ගොඩගේ ප්‍රකාශන | S.Godage Publisher",
          "url": "/collections/sgodage-publisher"
        },
        {
          "title": "උපාලි නිවුස්පේපර්ස් ( PVT) LTD | Upali Newspapers( pvt) LTD",
          "url": "/collections/upali-newspapers-pvt-ltd"
        },
        {
          "title": "එම්.ඩී. ගුණසේන මුද්‍රනකරුවෝ | M.D. Gunasena Printers",
          "url": "/collections/md-gunasena-printers"
        },
        {
          "title": "එම්ෆයර් එන්ටටෙට්මන්ට් ප්‍රකාශකයෝ | Empire Entertainment Publishers",
          "url": "/collections/empire-entertainment-publishers"
        },
        {
          "title": "එස් ඇන්ඩ් එස් ප්‍රින්ටර්ස් | S & S Printers",
          "url": "/collections/s-s-printers"
        },
        {
          "title": "ඒ ප්‍රකාශකයෝ | A Publications",
          "url": "/collections/a-publications"
        },
        {
          "title": "කඩුල්ල ප්‍රකාශන | Kadulla Publishers",
          "url": "/collections/kadulla-publishers"
        },
        {
          "title": "කර්තෘ ප්‍රකාශනයකි | Author publisher",
          "url": "/collections/author-publisher"
        },
        {
          "title": "කුරුලු පොත් ප්‍රකාශකයෝ | Kurulu Book Publishers",
          "url": "/collections/kurulu-book-publishers"
        },
        {
          "title": "කෙහෙළි ප්‍රකාශකයෝ | Keheli Publication",
          "url": "/collections/keheli-publication"
        },
        {
          "title": "කේබුක්ස් ප්‍රකාශන | KBOOKS Publishing",
          "url": "/collections/kbooks-publishing"
        },
        {
          "title": "කේලි ප්‍රකාශන | Kaylee Publications",
          "url": "/collections/kaylee-publications"
        },
        {
          "title": "ගයා ක්‍රියේෂන්ස් | Gaya Creations",
          "url": "/collections/gaya-creations"
        },
        {
          "title": "ගීම ප්‍රකාශන | Geema Prakashana",
          "url": "/collections/geema-prakashana"
        },
        {
          "title": "ග්‍රන්ථ ප්‍රකාශන | Grantha Publishers",
          "url": "/collections/grantha-publishers"
        },
        {
          "title": "චන්දන මෙන්ඩිස් ප්‍රකාශන | Chandana Mendis Prakashana",
          "url": "/collections/chandana-mendis-prakashana"
        },
        {
          "title": "ජයදද ප්‍රකාශකයෝ | Jayadada Publishers",
          "url": "/collections/jayadada-publishers"
        },
        {
          "title": "තරංග ප්‍රකාශකයෝ | Tharanga Publishers",
          "url": "/collections/tharanga-publishers"
        },
        {
          "title": "තාරා ප්‍රකාශකයෝ | Thara Publishers",
          "url": "/collections/thara-publishers"
        },
        {
          "title": "තාරුගේ සිද්ධි | Tharuge Siddhi",
          "url": "/collections/tharuge-siddhi"
        },
        {
          "title": "තෝතැන්න පබ්ලිෂින් හවුස් | Thothanna Publishing House",
          "url": "/collections/thothanna-publishing-house"
        },
        {
          "title": "දයාවංශ ජයකොඩි සහ සමාගම | Dayawansha Jayakodi saha Samagama",
          "url": "/collections/dayawansha-jayakodi-saha-samagama"
        },
        {
          "title": "දිනිසා ප්‍රකාශකයෝ | Dinisa publication",
          "url": "/collections/dinisa-publication"
        },
        {
          "title": "දෙව්මිනි ප්‍රකාශන | Dewmini Publication",
          "url": "/collections/dewmini-publication"
        },
        {
          "title": "නලින් ප්‍රකාශකයෝ | Nalin Publishers",
          "url": "/collections/nalin-publishers"
        },
        {
          "title": "නිමන්සා ප්‍රකාශන | Nimansa Publication",
          "url": "/collections/nimansa-publication"
        },
        {
          "title": "නිම්සර ප්‍රකාශන | Nimsara Publications",
          "url": "/collections/nimsara-publications"
        },
        {
          "title": "නිම්සා ප්‍රකාශන | Nimsaa Publication",
          "url": "/collections/nimsaa-publication"
        },
        {
          "title": "නිලුකා බ්‍රැන්ඩන් | TOUT Publication",
          "url": "/collections/tout-publication"
        },
        {
          "title": "නිශාන්ත ප්‍රකාශකයෝ | Nishantha Publishers",
          "url": "/collections/nishantha-publishers"
        },
        {
          "title": "නිශී පබ්ලිකේෂන්ස් | Nishee Publications",
          "url": "/collections/nishee-publications"
        },
        {
          "title": "නිසා බුක්ලන්ඩ් | Nisa Bookland",
          "url": "/collections/nisa-bookland"
        },
        {
          "title": "නෙත්රෝ ප්‍රකාශන | Nethro Publishers",
          "url": "/collections/nethro-publishers"
        },
        {
          "title": "නොහදුනන්නී ප්‍රකාශකයෝ | Nohandunanni Publications",
          "url": "/collections/nohandunanni-publications"
        },
        {
          "title": "පවන ක්‍රියේෂන්ස් | Pawana Creations",
          "url": "/collections/pawana-creations"
        },
        {
          "title": "පහන් ප්රකාශකයෝ | Pahan Publishers",
          "url": "/collections/pahan-publishers"
        },
        {
          "title": "පොත් ගුල්ලෝ | Poth Gullo",
          "url": "/collections/poth-gullo"
        },
        {
          "title": "ප්‍රතිභා ප්‍රකාශන | Prathibha Prakashana",
          "url": "/collections/prathibha-prakashana"
        },
        {
          "title": "ප්‍රමියර් ප්‍රකාශකයෝ | Pramiyar Publishers",
          "url": "/collections/pramiyar-publishers"
        },
        {
          "title": "ප්‍රියමාල් ප්‍රකාශන | Priyamal Publisher",
          "url": "/collections/priyamal-publisher"
        },
        {
          "title": "බටහිර අහස ප්‍රකාශකයෝ | Batahira Ahasa publishers",
          "url": "/collections/batahira-ahasa-publishers"
        },
        {
          "title": "බිග් බොස් ප්‍රකාශකයෝ | Big Boss Publishers",
          "url": "/collections/big-boss-publishers"
        },
        {
          "title": "බිසෝ ප්‍රකාශන | Biso Prakashana",
          "url": "/collections/biso-prakashana"
        },
        {
          "title": "බොරැල්ල විජය ප්‍රකාශකයෝ | Boralla Wijaya Publishers",
          "url": "/collections/boralla-wijaya-publishers"
        },
        {
          "title": "භරණ බුක්ස් | Bharana Books",
          "url": "/collections/bharana-books"
        },
        {
          "title": "මතක ප්‍රකාශකයෝ | Mathaka Publishers",
          "url": "/collections/mathaka-publishers"
        },
        {
          "title": "මිනර්වා ප්‍රකාශකයෝ | Minerva Publishers",
          "url": "/collections/minerva-publishers"
        },
        {
          "title": "මිනැස් | MINAS PUBLISHERS",
          "url": "/collections/minas-publishers"
        },
        {
          "title": "මියුසස් ප්‍රකාශකයෝ | Muses Publishers",
          "url": "/collections/muses-publishers"
        },
        {
          "title": "මූන්ලයිට් ප්‍රකාශකයෝ | Moonlight Publications",
          "url": "/collections/moonlight-publications"
        },
        {
          "title": "යසස් ප්‍රකාශන | Yasas Publishers",
          "url": "/collections/yasas-publishers"
        },
        {
          "title": "යාත්‍රා පබ්ලිෂ | Yathra Publisher",
          "url": "/collections/yathra-publisher"
        },
        {
          "title": "රත්න පොත් ප්‍රකාශකයෝ | Rathna Poth Prakashakayo",
          "url": "/collections/rathna-poth-prakashakayo"
        },
        {
          "title": "රත්සර පොත් | Rathsara Publishers",
          "url": "/collections/rathsara-publishers"
        },
        {
          "title": "රසකතා ප්‍රකාශන | Rasakatha Publishers",
          "url": "/collections/rasakatha-publishers"
        },
        {
          "title": "රූ ක්‍රියේෂන්ස් | Ruu Creations",
          "url": "/collections/ruu-creations"
        },
        {
          "title": "ලංකා පඤ්චාඬග | Lanka Panchanga",
          "url": "/collections/lanka-panchanga"
        },
        {
          "title": "ලර්න්වෙල් ප්‍රකාශකයෝ | LearnWell Publishers",
          "url": "/collections/learnwell-publishers"
        },
        {
          "title": "ලිබ්රෝ ප්‍රකාශන | Libro Publishers",
          "url": "/collections/libro-publishers"
        },
        {
          "title": "ලියනෝ | liyano",
          "url": "/collections/liyano"
        },
        {
          "title": "ලේඛක හා පාඨක සංසදය | Lekaka Ha Pataka Sansadaya",
          "url": "/collections/lekaka-ha-pataka-sansadaya"
        },
        {
          "title": "වර්ණ ග්‍රැෆික් සහ ප්‍රකාශන | Warna Graphic & Publications",
          "url": "/collections/warna-graphic-publications"
        },
        {
          "title": "විජිත යාපා ප්‍රකාශන | Vijitha Yapa Publishers",
          "url": "/collections/vijitha-yapa-publishers"
        },
        {
          "title": "විජේසුරිය ග්රන්ථ කේන්ද්රය | Vijesooriya Grantha Kendraya",
          "url": "/collections/vijesooriya-grantha-kendraya"
        },
        {
          "title": "විජේසූරිය ග්‍රන්ථ කේන්ද්‍රය | Wijesooriya Grantha Kendraya",
          "url": "/collections/wijesooriya-grantha-kendraya"
        },
        {
          "title": "විදර්ශන ප්‍රකාශන | Vidarshana Publishers",
          "url": "/collections/vidarshana-publishers"
        },
        {
          "title": "විශිෂ්ට ප්‍රකාශකයෝ | Wishishta Prakashakayo",
          "url": "/collections/wishishta-prakashakayo"
        },
        {
          "title": "ශාක්‍යාප්‍රකාශකයෝ | Shakya Publications",
          "url": "/collections/shakya-publications"
        },
        {
          "title": "ශික්ෂා මන්දිර ප්‍රකාශන | Shiksha Mandira Publishers",
          "url": "/collections/shiksha-mandira-publishers"
        },
        {
          "title": "සකිත්මා ප්‍රකාශන | Sakithma Publisher",
          "url": "/collections/sakithma-publisher"
        },
        {
          "title": "සංඛ ප්‍රකාශකයෝ | Sankha Publishers",
          "url": "/collections/sankha-publishers"
        },
        {
          "title": "සතර ප්‍රකාශකයෝ | Sathara Publishers",
          "url": "/collections/sathara-publishers"
        },
        {
          "title": "සදීපා ප්‍රකාශකයෝ | Sadeepa Publishers",
          "url": "/collections/sadeepa-publishers"
        },
        {
          "title": "සන්ථව ප්‍රකාශන | Santhawa Publication",
          "url": "/collections/santhawa-publication"
        },
        {
          "title": "සඳමාධවී ප්‍රකාශකයෝ | Sandamadhavee Publishers",
          "url": "/collections/sandamadhavee-publishers"
        },
        {
          "title": "සමන්ති පොත් ප්‍රකාශකයෝ | Samanthi publishers",
          "url": "/collections/samanthi-publishers"
        },
        {
          "title": "සමයවර්ධන පොත්හල | Samayawardhana Book shop",
          "url": "/collections/samayawardhana-book-shop"
        },
        {
          "title": "සයුර ප්‍රකාශකයෝ | Sayura publishers",
          "url": "/collections/sayura-publishers"
        },
        {
          "title": "සරස ප්‍රකාශකයෝ | Sarasa Publishers",
          "url": "/collections/sarasa-publishers"
        },
        {
          "title": "සරසවි ප්‍රකාශන | Sarasavi Publishers",
          "url": "/collections/sarasavi-publishers"
        },
        {
          "title": "සරස්වී ප්‍රකාශකයෝ | Saraswee Publications",
          "url": "/collections/saraswee-publications"
        },
        {
          "title": "සාර ප්‍රකාශන | Sara Publications",
          "url": "/collections/sara-publications"
        },
        {
          "title": "සාරවි ප්‍රකාශන | Saravi Publishers",
          "url": "/collections/saravi-publishers"
        },
        {
          "title": "සිතැඟි Creations | Sithangi Creations",
          "url": "/collections/creations-sithangi-creations"
        },
        {
          "title": "සිතුවිලි ප්‍රකාශන | Sithuwili Publishers",
          "url": "/collections/sithuwili-publishers"
        },
        {
          "title": "සිලිකා ප්‍රකාශකයෝ | Silika Publication",
          "url": "/collections/silika-publication"
        },
        {
          "title": "සුරස ප්‍රකාශකයෝ | Surasa (fast publishing)",
          "url": "/collections/surasa-fast-publishing"
        },
        {
          "title": "සුරිය ප්‍රකාශකයෝ | Surya Publishers",
          "url": "/collections/surya-publishers"
        },
        {
          "title": "සුසර ප්‍රකාශකයෝ | Susara Prakashakayo",
          "url": "/collections/susara-prakashakayo"
        },
        {
          "title": "සූරිය ප්‍රකාශකයෝ | Sooriya Publisher",
          "url": "/collections/sooriya-publisher"
        },
        {
          "title": "සේෆියා බුක්ස් | Sefia Books",
          "url": "/collections/sefia-books"
        },
        {
          "title": "සෝනා එන්ටර්ටෙට්මෙන්ට් | Sona Entertainment",
          "url": "/collections/sona-entertainment"
        },
        {
          "title": "ස්ටෝරිෆ්ලික්ස් ප්‍රකාශකයෝ | Storyflix publishers",
          "url": "/collections/storyflix-publishers"
        },
        {
          "title": "හිරුමලී ප්‍රකාශන | Hirumali Publisher",
          "url": "/collections/hirumali-publisher"
        },
        {
          "title": "හෙළදිව ප්‍රකාශන | Heladiwa Publishers",
          "url": "/collections/heladiwa-publishers"
        },
        {
          "title": "ෆාස්ට් පබ්ලිශින් | Fast Publishing",
          "url": "/collections/fast-publishing"
        }
      ],
      "#": [
        {
          "title": "3S Publishers",
          "url": "/collections/3s-publishers"
        }
      ],
      "A": [
        {
          "title": "Award Publisher",
          "url": "/collections/award-publisher"
        }
      ],
      "B": [
        {
          "title": "Bloomsbury",
          "url": "/collections/bloomsbury"
        },
        {
          "title": "Bookrack",
          "url": "/collections/bookrack"
        }
      ],
      "C": [
        {
          "title": "CR Publishers",
          "url": "/collections/cr-publishers"
        }
      ],
      "E": [
        {
          "title": "Egmont",
          "url": "/collections/egmont"
        },
        {
          "title": "Electric Monkey",
          "url": "/collections/electric-monkey"
        },
        {
          "title": "Embassy Books",
          "url": "/collections/embassy-books"
        },
        {
          "title": "Enee's Book Cabin Publishers",
          "url": "/collections/enees-book-cabin-publishers"
        },
        {
          "title": "Epa Printers (Pvt) Ltd",
          "url": "/collections/epa-printers-pvt-ltd"
        }
      ],
      "G": [
        {
          "title": "Gihan Book Shop",
          "url": "/collections/gihan-book-shop"
        },
        {
          "title": "Ginn",
          "url": "/collections/ginn"
        }
      ],
      "H": [
        {
          "title": "Hachette Children's Group",
          "url": "/collections/hachette-childrens-group"
        },
        {
          "title": "Harper Collins Publishers",
          "url": "/collections/harper-collins-publishers"
        },
        {
          "title": "Hot Key Books",
          "url": "/collections/hot-key-books"
        },
        {
          "title": "Hutchinson Publishers",
          "url": "/collections/hutchinson-publishers"
        }
      ],
      "I": [
        {
          "title": "IBMC ප්‍රකාශන | IBMC Publisher",
          "url": "/collections/ibmc-ibmc-publisher"
        },
        {
          "title": "IMASHI PUBLICATION",
          "url": "/collections/imashi-publication"
        }
      ],
      "J": [
        {
          "title": "Jaico Publishing House",
          "url": "/collections/jaico-publishing-house"
        },
        {
          "title": "Joan Creations",
          "url": "/collections/joan-creations"
        }
      ],
      "K": [
        {
          "title": "KBOOKS PUBLISHING",
          "url": "/collections/kbooks-publishing-2"
        },
        {
          "title": "KHEMA PUBLICATIONS",
          "url": "/collections/khema-publications"
        }
      ],
      "L": [
        {
          "title": "Ladybird Tales",
          "url": "/collections/ladybird-tales"
        }
      ],
      "M": [
        {
          "title": "Macmillan Education India Private Limited",
          "url": "/collections/macmillan-education-india-private-limited"
        },
        {
          "title": "Master Guide Publication",
          "url": "/collections/master-guide-publication"
        }
      ],
      "N": [
        {
          "title": "Naught Creations",
          "url": "/collections/naught-creations"
        },
        {
          "title": "Nethwin Printers",
          "url": "/collections/nethwin-printers"
        },
        {
          "title": "New Holland Publishers",
          "url": "/collections/new-holland-publishers"
        },
        {
          "title": "Nonimi Prakashana",
          "url": "/collections/nonimi-prakashana"
        },
        {
          "title": "Nuwana Prakashana",
          "url": "/collections/nuwana-prakashana"
        }
      ],
      "O": [
        {
          "title": "Om Books International",
          "url": "/collections/om-books-international"
        },
        {
          "title": "Orion House",
          "url": "/collections/orion-house"
        },
        {
          "title": "OrionBook Publications",
          "url": "/collections/orionbook-publications"
        }
      ],
      "P": [
        {
          "title": "Penguin Books",
          "url": "/collections/penguin-books"
        },
        {
          "title": "Penguin Books Limited",
          "url": "/collections/penguin-books-limited"
        },
        {
          "title": "Perseus Books Group",
          "url": "/collections/perseus-books-group"
        },
        {
          "title": "Plata Publishing",
          "url": "/collections/plata-publishing"
        },
        {
          "title": "Pothak.lk",
          "url": "/collections/pothaklk"
        },
        {
          "title": "Pothmee Publication",
          "url": "/collections/pothmee-publication"
        },
        {
          "title": "Puffin Publishers",
          "url": "/collections/puffin-publishers"
        }
      ],
      "R": [
        {
          "title": "Random House Business",
          "url": "/collections/random-house-business"
        },
        {
          "title": "Reader's Hub",
          "url": "/collections/readers-hub"
        },
        {
          "title": "Reading Planet",
          "url": "/collections/reading-planet"
        },
        {
          "title": "Red Castle Graphic",
          "url": "/collections/red-castle-graphic"
        }
      ],
      "S": [
        {
          "title": "S & T Group",
          "url": "/collections/s-t-group"
        },
        {
          "title": "S ගොඩගේ සහ සහෝදරයෝ | S Godage saha Sahodarayo",
          "url": "/collections/s-godage-saha-sahodarayo"
        },
        {
          "title": "Samudra Book Publication",
          "url": "/collections/samudra-book-publication"
        },
        {
          "title": "Sandali Poth Prakashana",
          "url": "/collections/sandali-poth-prakashana"
        },
        {
          "title": "Shan Poth Prakashakayo",
          "url": "/collections/shan-poth-prakashakayo"
        },
        {
          "title": "Simon & Schuster Nickelodeon",
          "url": "/collections/simon-schuster-nickelodeon"
        },
        {
          "title": "Simon & Schuster Publishers",
          "url": "/collections/simon-and-schuster-publishers"
        },
        {
          "title": "Simon Schuster",
          "url": "/collections/simon-schuster"
        },
        {
          "title": "Sinhala Panthiya Publication",
          "url": "/collections/sinhala-panthiya-publication"
        },
        {
          "title": "Stamford Lake Publication",
          "url": "/collections/stamford-lake-publication"
        }
      ],
      "T": [
        {
          "title": "TASHEN PUBLICATION",
          "url": "/collections/tashen-publication"
        },
        {
          "title": "Thorsons Publishers",
          "url": "/collections/thorsons-publishers"
        }
      ],
      "U": [
        {
          "title": "Udaya Publishers",
          "url": "/collections/udaya-publishers"
        },
        {
          "title": "Usborne Publishing Ltd",
          "url": "/collections/usborne-publishing-ltd"
        }
      ],
      "W": [
        {
          "title": "Walker Books",
          "url": "/collections/walker-books"
        },
        {
          "title": "Wilco Book",
          "url": "/collections/wilco-book"
        },
        {
          "title": "Woodpecker Books",
          "url": "/collections/woodpecker-books"
        }
      ]
    }
  },
  {
    "title": "By Stationery",
    "index": [
      "C",
      "E",
      "F",
      "G",
      "H",
      "M",
      "P",
      "S",
      "W"
    ],
    "groupedItems": {
      "C": [
        {
          "title": "Clay",
          "url": "/collections/clay"
        },
        {
          "title": "Colour Pencils",
          "url": "/collections/colour-pencils"
        }
      ],
      "E": [
        {
          "title": "Excercise-CR-B5-Practical-Drawing-Books",
          "url": "/collections/excercise-cr-b5-practical-drawing-books"
        }
      ],
      "F": [
        {
          "title": "Felt Pens",
          "url": "/collections/felt-pens"
        }
      ],
      "G": [
        {
          "title": "Glue",
          "url": "/collections/glue"
        }
      ],
      "H": [
        {
          "title": "Highlighter",
          "url": "/collections/highlighter"
        }
      ],
      "M": [
        {
          "title": "Marker Pen",
          "url": "/collections/marker-pen"
        }
      ],
      "P": [
        {
          "title": "Papers",
          "url": "/collections/papers"
        },
        {
          "title": "Pastels",
          "url": "/collections/pastels"
        }
      ],
      "S": [
        {
          "title": "Scissors",
          "url": "/collections/scissors"
        }
      ],
      "W": [
        {
          "title": "Water Colours",
          "url": "/collections/water-colours"
        }
      ]
    }
  },
  {
    "title": "By Brand",
    "index": [
      "A",
      "C",
      "D",
      "F",
      "H",
      "I",
      "J",
      "M",
      "N",
      "P",
      "R",
      "S",
      "W"
    ],
    "groupedItems": {
      "A": [
        {
          "title": "Acron",
          "url": "/collections/acron"
        },
        {
          "title": "Atlas",
          "url": "/collections/atlas"
        }
      ],
      "C": [
        {
          "title": "Camlin",
          "url": "/collections/camlin"
        },
        {
          "title": "Chemifix",
          "url": "/collections/chemifix"
        }
      ],
      "D": [
        {
          "title": "Deli",
          "url": "/collections/deli"
        },
        {
          "title": "DOMS",
          "url": "/collections/doms"
        },
        {
          "title": "Dumindu",
          "url": "/collections/dumindu"
        }
      ],
      "F": [
        {
          "title": "Fevicryl",
          "url": "/collections/fevicryl"
        }
      ],
      "H": [
        {
          "title": "Hauser",
          "url": "/collections/hauser"
        },
        {
          "title": "Homerun",
          "url": "/collections/homerun"
        }
      ],
      "I": [
        {
          "title": "Innovate",
          "url": "/collections/innovate"
        }
      ],
      "J": [
        {
          "title": "JK",
          "url": "/collections/jk"
        }
      ],
      "M": [
        {
          "title": "Mango",
          "url": "/collections/mango"
        },
        {
          "title": "Maped",
          "url": "/collections/maped"
        },
        {
          "title": "Master Guide",
          "url": "/collections/master-guide"
        }
      ],
      "N": [
        {
          "title": "Nataraj",
          "url": "/collections/nataraj"
        },
        {
          "title": "NSG",
          "url": "/collections/nsg"
        }
      ],
      "P": [
        {
          "title": "Pentium",
          "url": "/collections/pentium"
        },
        {
          "title": "ProMate",
          "url": "/collections/promate"
        }
      ],
      "R": [
        {
          "title": "Richard",
          "url": "/collections/richard"
        }
      ],
      "S": [
        {
          "title": "Sammanee",
          "url": "/collections/sammanee"
        }
      ],
      "W": [
        {
          "title": "Weerodara",
          "url": "/collections/weerodara"
        }
      ]
    }
  }
];
